export function Standard_Case_GetCase(id) {
    var url = "/Standard/Case/GetCase";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function Standard_Case_CaseClosed(id) {
    var url = "/Standard/Case/CaseClosed";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function Unilever_Home_InsuranceYearList(insured, claimant) {
    var url = "/Unilever/Home/InsuranceYearList";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&claimant=" + encodeURIComponent(claimant);

    return url;
}

export function  Unilever_Home_InsuredList() {
    var url = "/Unilever/Home/InsuredList";
    return url;
}

export function  Unilever_Home_ClaimantList() {
    var url = "/Unilever/Home/ClaimantList";
    return url;
}

export function  Unilever_Home_PolicyList() {
    var url = "/Unilever/Home/PolicyList";
    return url;
}

export function  Unilever_Home_GroupList() {
    var url = "/Unilever/Home/GroupList";
    return url;
}

export function  Unilever_Home_GeneralList(policy, year, claimant, insured, group, pageSize, pageNumber, orderBy, orderAsc) {
    var url = "/Unilever/Home/GeneralList";
    url = url + "?insuredId=" + encodeURIComponent(insured);
    url = url + "&claimantId=" + encodeURIComponent(claimant);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&groupId=" + encodeURIComponent(group);
    url = url + "&policyId=" + encodeURIComponent(policy);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

export function  Unilever_Home_MonthlyList(policy, year, claimant, insured, group) {
    var url = "/Unilever/Home/MonthlyList";
    url = url + "?insuredId=" + encodeURIComponent(insured);
    url = url + "&claimantId=" + encodeURIComponent(claimant);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&groupId=" + encodeURIComponent(group);
    url = url + "&policyId=" + encodeURIComponent(policy);

    return url;
}

export function  Unilever_Home_DownloadGeneralReport(policy, year, claimant, insured, group) {
    var url = "/Unilever/Home/DownloadGeneralReport";
    url = url + "?insuredId=" + encodeURIComponent(insured);
    url = url + "&claimantId=" + encodeURIComponent(claimant);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&groupId=" + encodeURIComponent(group);
    url = url + "&policyId=" + encodeURIComponent(policy);

    return url;
}

export function  Unilever_Home_DownloadMonthlyReport(policy, year, claimant, insured, group) {
    var url = "/Unilever/Home/DownloadMonthlyReport";
    url = url + "?insuredId=" + encodeURIComponent(insured);
    url = url + "&claimantId=" + encodeURIComponent(claimant);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&groupId=" + encodeURIComponent(group);
    url = url + "&policyId=" + encodeURIComponent(policy);

    return url;
}

export function  Unilever_Home_UniCargoLossRatioReport() {
    var url = "/Unilever/Home/UniCargoLossRatioReport";

    return url;
}

export function Standard_CustomReport_UniCargoClaimsReport() {
    var url = "/Standard/CustomReport/UniCargoClaimsReport";

    return url;
}

export function  Chubb_Home_InsuranceYearList(insured, claimant) {
    var url = "/Chubb/Home/InsuranceYearList";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&claimant=" + encodeURIComponent(claimant);

    return url;
}

export function  Chubb_Home_InsuredList() {
    var url = "/Chubb/Home/InsuredList";
    return url;
}

export function  Chubb_Home_ClaimantList() {
    var url = "/Chubb/Home/ClaimantList";
    return url;
}

export function  Chubb_Home_CaseList(insured, claimant, year, wkwReference, orderBy, orderAsc, pageSize, pageNumber) {
    var url = "/Chubb/Home/CaseList";
    url = url + "?insuredId=" + encodeURIComponent(insured);
    url = url + "&claimantId=" + encodeURIComponent(claimant);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

export function  Chubb_Home_DownloadGeneralReport(insured, claimant, year, wkwReference) {
    var url = "/Chubb/Home/DownloadGeneralReport";
    url = url + "?insuredId=" + encodeURIComponent(insured);
    url = url + "&claimantId=" + encodeURIComponent(claimant);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);

    return url;
}

//export function  Chubb_Home_InsuranceYearList() {
//    var url = "/Chubb/Home/InsuranceYearList";
//    return url;
//}

export function  Chubb_Home_MonthlyList(year) {
    var url = "/Chubb/Home/MonthlyList";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function  Chubb_Home_DownloadMonthlyReport(year) {
    var url = "/Chubb/Home/DownloadMonthlyReport";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function  Standard_Home_InsurerList(prefix) {
    var url = "/Standard/Home/InsurerList";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function  Standard_Home_InsuredList(prefix, search) {
    var url = "/Standard/Home/InsuredList";
    url = url + "?prefix=" + encodeURIComponent(prefix);
    url = url + "&search=" + encodeURIComponent(search);

    return url;
}

export function Standard_Home_InsuredCount(prefix) {
    var url = "/Standard/Home/InsuredCount";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function  Standard_Home_WkwReferenceList(match) {
    var url = "/Standard/Home/WkwReferenceList";
    url = url + "?match=" + encodeURIComponent(match);

    return url;
}

export function  Standard_Home_CasePrefixList() {
    var url = "/Standard/Home/CasePrefixList";

    return url;
}

export function  Standard_Home_CaseList(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/Standard/Home/CaseList";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function  Standard_Home_DownloadCaseReport(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix) {
    var url = "/Standard/Home/DownloadCaseReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);

    return url;
}

export function  Jas_Home_PolicyPeriodList(cnaPolicyNumber, insurer) {
    var url = "/Jas/Home/PolicyPeriodList";
    url = url + "?cnaPolicyNumber=" + encodeURIComponent(cnaPolicyNumber);
    url = url + "&insurer=" + encodeURIComponent(insurer);

    return url;
}

export function  Jas_Home_InsuredEntityList(cnaPolicyNumber, insurer) {
    var url = "/Jas/Home/InsuredEntityList";
    url = url + "?cnaPolicyNumber=" + encodeURIComponent(cnaPolicyNumber);
    url = url + "&insurer=" + encodeURIComponent(insurer);

    return url;
}

export function  Jas_Home_NotifyingEntityList(cnaPolicyNumber, insurer) {
    var url = "/Jas/Home/NotifyingEntityList";
    url = url + "?cnaPolicyNumber=" + encodeURIComponent(cnaPolicyNumber);
    url = url + "&insurer=" + encodeURIComponent(insurer);

    return url;
}

export function  Jas_Home_ClaimSubtypeList(claimType) {
    var url = "/Jas/Home/ClaimSubtypeList";
    url = url + "?claimType=" + encodeURIComponent(claimType);

    return url;
}

export function  Jas_Home_CanPolicyNumberList() {
    var url = "/Jas/Home/CnaPolicyNumberList";
    return url;
}

export function  Jas_Home_InsurerList() {
    var url = "/Jas/Home/InsurerList";
    return url;
}

export function  Jas_Home_ClaimTypeList() {
    var url = "/Jas/Home/ClaimTypeList";
    return url;
}

export function  Jas_Home_RecoveryReport() {
    var url = "/Jas/Home/RecoveryReport";

    return url;
}

export function  Jas_Home_CaseList(cnaPolicyNumber,
    insurer,
    policyPeriod,
    wkwReference,
    insuredEntity,
    notifyingEntity,
    claimType,
    claimSubtype,
    orderBy,
    orderAsc,
    pageSize,
    pageNumber) {

    var url = "/Jas/Home/CaseList";
    url = url + "?cnaPolicyNumber=" + encodeURIComponent(cnaPolicyNumber);
    url = url + "&insurer=" + encodeURIComponent(insurer);
    url = url + "&policyPeriod=" + encodeURIComponent(policyPeriod);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);

    url = url + "&insuredEntity=" + encodeURIComponent(insuredEntity);
    url = url + "&notifyingEntity=" + encodeURIComponent(notifyingEntity);
    url = url + "&claimType=" + encodeURIComponent(claimType);
    url = url + "&claimSubtype=" + encodeURIComponent(claimSubtype);

    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

export function  Jas_Home_DownloadCaseList(cnaPolicyNumber,
    insurer,
    policyPeriod,
    wkwReference,
    insuredEntity,
    notifyingEntity,
    claimType,
    claimSubtype) {
    var url = "/Jas/Home/DownloadCaseList";
    url = url + "?cnaPolicyNumber=" + encodeURIComponent(cnaPolicyNumber);
    url = url + "&insurer=" + encodeURIComponent(insurer);
    url = url + "&policyPeriod=" + encodeURIComponent(policyPeriod);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);

    url = url + "&insuredEntity=" + encodeURIComponent(insuredEntity);
    url = url + "&notifyingEntity=" + encodeURIComponent(notifyingEntity);
    url = url + "&claimType=" + encodeURIComponent(claimType);
    url = url + "&claimSubtype=" + encodeURIComponent(claimSubtype);

    return url;
}

export function  Standard_CustomReport_GetReports() {
    var url = "/Standard/CustomReport/GetReports";

    return url;
}

export function  Standard_CustomReport_AgcsLineOfBusinessAnalysis() {
    var url = "/Standard/CustomReport/AgcsLineOfBusinessAnalysis";

    return url;
}

export function  Standard_CustomReport_AgcsQuarterlyStatistics() {
    var url = "/Standard/CustomReport/AgcsQuarterlyStatistics";

    return url;
}

export function  Standard_CustomReport_AgcsQuarterlyStatisticsByDate(startDate, endDate) {
    var url = "/Standard/CustomReport/AgcsQuarterlyStatisticsByDate";
    url = url + "?startTime=" + encodeURIComponent(startDate);
    url = url + "&endTime=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_AljGeneralReport() {
    var url = "/Standard/CustomReport/AljGeneralReport";

    return url;
}

export function Standard_CustomReport_AljSparePartsReport() {
    var url = "/Standard/CustomReport/AljSparePartsReport";

    return url;
}

export function Standard_CustomReport_ChubbSubrogationSummary() {
    var url = "/Standard/CustomReport/ChubbSubrogationSummary";

    return url;
}

export function Standard_CustomReport_NokiaInsurerList() {
    var url = "/Standard/CustomReport/NokiaInsurerList";

    return url;
}

export function Standard_CustomReport_NokiaYearList(insurer) {
    var url = "/Standard/CustomReport/NokiaYearList";

    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Standard_CustomReport_NokiaLossRun(insurer, insuranceYear) {
    var url = "/Standard/CustomReport/NokiaLossRun";

    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insuranceYear=" + encodeURIComponent(insuranceYear);

    return url;
}

export function Standard_CustomReport_NokiaNetworksReport(startDate, endDate) {
    var url = "/Standard/CustomReport/NokiaNetworksReport";

    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}


export function Standard_CustomReport_NokiaRecoveryReport(insurer, startDate, endDate) {
    var url = "/Standard/CustomReport/NokiaRecoveryReport";

    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_GoldCoinGeneralReport() {
    var url = "/Standard/CustomReport/GoldCoinGeneralReport";

    return url;
}


export function Standard_CustomReport_DaewooGeneralReport() {
    var url = "/Standard/CustomReport/DaewooGeneralReport";

    return url;
}

export function Standard_CustomReport_InternationalPaperYearList() {
    var url = "/Standard/CustomReport/InternationalPaperYearList";

    return url;
}

export function Standard_CustomReport_InternationalPaperGeneralReport(year) {
    var url = "/Standard/CustomReport/InternationalPaperGeneralReport";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_InternationalPaperMonthlyReport(year, month) {
    var url = "/Standard/CustomReport/InternationalPaperMonthlyReport";
    url = url + "?year=" + year;
    url = url + "&month=" + encodeURIComponent(month);

    return url;
}

export function Standard_CustomReport_SecureLeaseBinderYearList() {
    var url = "/Standard/CustomReport/SecureLeaseBinderYearList";

    return url;
}

function secureLeaseCustomReport(url, insurer) {
    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Standard_CustomReport_SecureLeaseGeneralReport(insurer) {
    return secureLeaseCustomReport("/Standard/CustomReport/SecureLeaseGeneralReport", insurer);
}

export function Standard_CustomReport_SecureLeaseDominionReport(insurer) {
    return secureLeaseCustomReport("/Standard/CustomReport/SecureLeaseDominionReport", insurer);
}

export function Standard_CustomReport_SecureLeaseStorageReport(insurer) {
    return secureLeaseCustomReport("/Standard/CustomReport/SecureLeaseStorageReport", insurer);
}

export function Standard_CustomReport_SecureLeaseRgCanadaReport(insurer) {
    return secureLeaseCustomReport("/Standard/CustomReport/SecureLeaseRgCanadaReport", insurer);
}


export function  Oim_Home_CaseList(
    orderBy,
    orderAsc,
    pageSize,
    pageNumber) {

    var url = "/Oim/Home/CaseList";
    url = url + "?orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

export function  Oim_Home_DownloadAmlinReport() {

    var url = "/Oim/Home/DownloadAmlinReport";

    return url;
}

export function  Oim_Home_DownloadWatkinsReport() {

    var url = "/Oim/Home/DownloadWatkinsReport";

    return url;
}

export function  Standard_Report_GetUserAccess() {
    var url = "/Standard/Report/GetUserAccess";

    return url;
}

export function  Standard_Report_GetGroupList() {
    var url = "/Standard/Report/GetGroupList";

    return url;
}

//function standardReport(url, group, prefix, insurer, insured, dateFrom, dateTo) {
//    url = url + "?group=" + group;
//    url = url + "&prefix=" + prefix;
//    url = url + "&insurer=" + insurer;
//    url = url + "&insured=" + insured;
//    url = url + "&dateFrom=" + dateFrom;
//    url = url + "&dateTo=" + dateTo;

//    return url;
//}

export function  Standard_Report_AllCasesReport() {
    var url = "/Standard/Report/AllCasesReport";

    return url;
}

export function Standard_Report_AllOpenCasesReport() {
    var url = "/Standard/Report/AllOpenCasesReport";

    return url;
}

export function  Standard_Report_OpenCargoReport() {
    var url = "/Standard/Report/OpenCargoReport";

    return url;
}

export function  Standard_Report_OpenRecoveriesReport() {
    var url = "/Standard/Report/OpenRecoveriesReport";

    return url;
}

export function  Standard_Report_ConcludedRecoveriesReport() {
    var url = "/Standard/Report/ConcludedRecoveriesReport";

    return url;
}

export function WellsFargo_Report_AllCasesReport() {
    return "/WellsFargo/Report/AllCasesReport";
}

export function WellsFargo_Report_AllOpenCasesReport() {
    return "/WellsFargo/Report/AllOpenCasesReport";
}

export function WellsFargo_Report_OpenCargoReport() {
    return "/WellsFargo/Report/OpenCargoReport";
}

export function WellsFargo_Report_OpenRecoveriesReport() {
    return "/WellsFargo/Report/OpenRecoveriesReport";
}

export function WellsFargo_Report_ConcludedRecoveriesReport() {
    return "/WellsFargo/Report/ConcludedRecoveriesReport";
}

export function Unirisc_Report_AllCasesReport() {
    return "/Unirisc/Report/AllCasesReport";
}

export function Unirisc_Report_AllOpenCasesReport() {
    return "/Unirisc/Report/AllOpenCasesReport";
}

export function Unirisc_Report_OpenCargoReport() {
    return "/Unirisc/Report/OpenCargoReport";
}

export function Unirisc_Report_OpenRecoveriesReport() {
    return "/Unirisc/Report/OpenRecoveriesReport";
}

export function Unirisc_Report_ConcludedRecoveriesReport() {
    return "/Unirisc/Report/ConcludedRecoveriesReport";
}

export function GeneralReport(url, group, prefix, insurer, insured, dateFrom, dateTo) {
    url = url + "?group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);

    return url;
}

export function  Admin_Application_GetApplications() {
    var url = "/Admin/Application/GetApplications";

    return url;
}


export function  Admin_Application_Get(id) {
    var url = "/Admin/Application/Get";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function  Admin_Application_Create() {
    var url = "/Admin/Application/Create";

    return url;
}

export function  Admin_Application_Update() {
    var url = "/Admin/Application/Update";

    return url;
}

export function  Admin_Report_GetReports() {
    var url = "/Admin/Report/GetReports";

    return url;
}

export function  Admin_Report_Get(id) {
    var url = "/Admin/Report/Get";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}


export function  Admin_Report_Create() {
    var url = "/Admin/Report/Create";

    return url;
}

export function  Admin_Report_Update() {
    var url = "/Admin/Report/Update";

    return url;
}

export function  Admin_Report_UserDropDown() {
    var url = "/Admin/Report/UserDropDown";

    return url;
}

export function  Admin_Report_ApplicationDropDown(userId) {
    var url = "/Admin/Report/ApplicationDropDown";
    url = url + "?userId=" + encodeURIComponent(userId);

    return url;
}

export function  Admin_Report_AddUser() {
    var url = "/Admin/Report/AddUser";

    return url;
}

export function  Admin_Report_RemoveUser(id) {
    var url = "/Admin/Report/RemoveUser";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function  Admin_SystemUser_GetUserList(filter, orderBy, orderAsc, pageSize, pageNumber) {
    var url = "/Admin/SystemUser/GetUserList";
    url = url + "?filter=" + encodeURIComponent(filter);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

export function  Admin_SystemUser_CreateUser(password) {
    var url = "/Admin/SystemUser/CreateUser";
    url = url + "?password=" + encodeURIComponent(password);

    return url;
}

export function  Admin_SystemUser_UpdateUser() {
    var url = "/Admin/SystemUser/UpdateUser";

    return url;
}

export function  Admin_SystemUser_GetUser(id) {
    var url = "/Admin/SystemUser/GetUser";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function  Admin_SystemUser_SecurityRoleDropDown() {
    var url = "/Admin/SystemUser/SecurityRoleDropDown";

    return url;
}

export function  Admin_SystemUser_GetLoginList(userId, dateFrom, dateTo, successful, orderBy, orderAsc, pageSize, pageNumber) {
    var url = "/Admin/SystemUser/GetLoginList";
    url = url + "?userId=" + encodeURIComponent(userId);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);
    url = url + "&successful=" + encodeURIComponent(successful);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

export function Admin_SystemUser_GetActiveSessions() {
    var url = "/Admin/SystemUser/GetActiveSessions";

    return url;
}

export function Admin_SystemUser_LogOutUser(userId) {
    var url = "/Admin/SystemUser/LogOutUser";
    url = url + "?userId=" + encodeURIComponent(userId); 

    return url;
}

export function  Admin_SystemUser_ResetPassword(userId, password) {
    var url = "/Admin/SystemUser/ResetPassword";

    url = url + "?userId=" + encodeURIComponent(userId);
    url = url + "&password=" + encodeURIComponent(password);

    return url;
}

export function  Standard_Login_ConfirmPassword(password) {
    var url = "/Standard/Login/ConfirmPassword";
    url = url + "?password=" + encodeURIComponent(password);

    return url;
}

export function  Standard_Login_ResetPassword(password) {
    var url = "/Standard/Login/ResetPassword";
    url = url + "?password=" + encodeURIComponent(password);

    return url;
}

export function  Admin_Group_GetGroups() {
    var url = "/Admin/Group/GetGroups";

    return url;
}

export function  Admin_Group_GetGroup(id) {
    var url = "/Admin/Group/GetGroup";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function  Admin_Group_CreateGroup() {
    var url = "/Admin/Group/CreateGroup";

    return url;
}

export function  Admin_Group_UpdateGroup() {
    var url = "/Admin/Group/UpdateGroup";

    return url;
}

export function  Admin_Group_GetGroupDropDown() {
    var url = "/Admin/Group/GetGroupDropDown";

    return url;
}

export function  Admin_Group_GetGroupMembers(groupId) {
    var url = "/Admin/Group/GetGroupMembers";
    url = url + "?groupId=" + encodeURIComponent(groupId);

    return url;
}

export function  Admin_Group_AddGroupMember() {
    var url = "/Admin/Group/AddGroupMember";

    return url;
}

export function  Admin_Group_RemoveGroupMember(id) {
    var url = "/Admin/Group/RemoveGroupMember";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function  Admin_UserAccess_GetUserAccessList(userId, applicationId, pageSize, pageNumber) {
    var url = "/Admin/UserAccess/GetUserAccessList";
    url = url + "?userId=" + encodeURIComponent(userId);
    url = url + "&applicationId=" + encodeURIComponent(applicationId);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

export function  Admin_UserAccess_GetUserAccess(id) {
    var url = "/Admin/UserAccess/GetUserAccess";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function  Admin_UserAccess_DeleteUserAccess(id) {
    var url = "/Admin/UserAccess/DeleteUserAccess";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function  Admin_UserAccess_CreateUserAccess() {
    var url = "/Admin/UserAccess/CreateUserAccess";

    return url;
}

export function  Admin_UserAccess_UpdateUserAccess() {
    var url = "/Admin/UserAccess/UpdateUserAccess";

    return url;
}

export function  Admin_SystemUser_GetReportList(userId) {
    var url = "/Admin/SystemUser/GetReportList";
    url = url + "?systemUserId=" + encodeURIComponent(userId);

    return url;
}

export function  Admin_SystemUser_GetAccessList(userId) {
    var url = "/Admin/SystemUser/GetAccessList";
    url = url + "?systemUserId=" + encodeURIComponent(userId);

    return url;
}

export function  Admin_UserAccess_GetApplicationUsers(applicationId) {
    var url = "/Admin/UserAccess/GetApplicationUsers";
    url = url + "?applicationId=" + encodeURIComponent(applicationId);

    return url;
}

export function  Sabic_Home_ProjectList() {
    var url = "/Sabic/Home/ProjectList";

    return url;
}

export function  Sabic_Home_InsuranceYearList(project) {
    var url = "/Sabic/Home/InsuranceYearList";
    url = url + "?project=" + encodeURIComponent(project);

    return url;
}

export function  Sabic_Home_CaseList(project, year, pageSize, pageNumber, orderBy, orderAsc) {
    var url = "/Sabic/Home/CaseList";
    url = url + "?project=" + encodeURIComponent(project);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function  Sabic_Home_MonthlyList(project, year) {
    var url = "/Sabic/Home/MonthlyList";
    url = url + "?project=" + encodeURIComponent(project);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function  Sabic_Home_DownloadGeneralReport(project, year) {
    var url = "/Sabic/Home/DownloadGeneralReport";
    url = url + "?project=" + encodeURIComponent(project);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function  Sabic_Home_DownloadMonthlyReport(project, year) {
    var url = "/Sabic/Home/DownloadMonthlyReport";
    url = url + "?project=" + encodeURIComponent(project);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_CnaSubro_InsuredList() {
    var url = "/Dashboards/CnaSubro/InsuredList";

    return url;
}

export function Dashboards_CnaSubro_YearList() {
    var url = "/Dashboards/CnaSubro/YearList";

    return url;
}

export function Dashboards_CnaSubro_RecoveryAmountsByYear(year, insured, successfulOnly) {
    var url = "/Dashboards/CnaSubro/RecoveryAmountsByYear";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&successfulOnly=" + encodeURIComponent(successfulOnly);

    return url;
}

export function Dashboards_CnaSubro_ClaimsSummary(year, insured){
    var url = "/Dashboards/CnaSubro/ClaimsSummary";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Dashboards_CnaSubro_RecoveryAmountsByTransport(year, insured) {
    var url = "/Dashboards/CnaSubro/RecoveryAmountsByTransport";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Dashboards_CnaSubro_ReasonsForNoRecovery(year, insured) {
    var url = "/Dashboards/CnaSubro/ReasonsForNoRecovery";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Dashboards_CnaSubro_ClaimValues(year, insured) {
    var url = "/Dashboards/CnaSubro/ClaimValues";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Dashboards_CnaSubro_ClaimsByCarrier(year, insured) {
    var url = "/Dashboards/CnaSubro/ClaimsByCarrier";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Dashboards_CnaSubro_GrossRecoveryData(year, insured) {
    var url = "/Dashboards/CnaSubro/GrossRecoveryData";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Dashboards_LamResearch_OpponentList() {
    var url = "/Dashboards/LamResearch/OpponentList";

    return url;
}

function lamResearchDashboard(url, prefix, year, quarter, opponent) {
    url = url + "?prefix=" + encodeURIComponent(prefix);
    url = url + "&year=" + encodeURIComponent(year);
    url = url + "&quarter=" + encodeURIComponent(quarter);
    url = url + "&opponent=" + encodeURIComponent(opponent);

    return url;
}

export function Dashboards_LamResearch_GrossClaimAmount(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/GrossClaimAmount", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_GrossClaimAmountCases(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/GrossClaimAmountCases", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_GrossRecovery(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/GrossRecovery", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_GrossRecoveryCases(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/GrossRecoveryCases", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_EstimatedGrossRecovery(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/EstimatedGrossRecovery", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_EstimatedGrossRecoveryCases(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/EstimatedGrossRecoveryCases", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_OpenVsClosed(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/OpenVsClosed", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_OpenClaims(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/OpenClaims", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_ClaimsByOpponent(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/ClaimsByOpponent", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_CauseOfLoss(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/CauseOfLoss", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_BiggestClaims(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/BiggestClaims", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_NewClaimsByMonth(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/NewClaimsByMonth", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_ReasonsForNoRecovery(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/ReasonsForNoRecovery", prefix, year, quarter, opponent);
}

export function Dashboards_LamResearch_ClaimsByOpponentByMonth(prefix, year, quarter, opponent) {

    return lamResearchDashboard("/Dashboards/LamResearch/ClaimsByOpponentByMonth", prefix, year, quarter, opponent);
}

export function Dashboards_Nokia_YearList() {
    var url = "/Dashboards/Nokia/YearList";

    return url;
}

export function Dashboards_Nokia_InsurerList() {
    var url = "/Dashboards/Nokia/InsurerList";

    return url;
}

function nokiaDashboard(url, insurer, year) {
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Nokia_RecoveriesByYear(insurer, year, successfulOnly) {
    var url = nokiaDashboard("/Dashboards/Nokia/RecoveriesByYear", insurer, year);
    url = url + "&successfulOnly=" + encodeURIComponent(successfulOnly);

    return url;
}

export function Dashboards_Nokia_ClaimsSummary(insurer, year) {
    return nokiaDashboard("/Dashboards/Nokia/ClaimsSummary", insurer, year);
}

export function Dashboards_Nokia_RecoveriesByTransit(insurer, year) {
    return nokiaDashboard("/Dashboards/Nokia/RecoveriesByTransit", insurer, year);
}

export function Dashboards_Nokia_ReasonsForNoRecovery(insurer, year) {
    return nokiaDashboard("/Dashboards/Nokia/ReasonsForNoRecovery", insurer, year);
}

export function Dashboards_Nokia_ClaimValueAmounts(insurer, year) {
    return nokiaDashboard("/Dashboards/Nokia/ClaimValueAmounts", insurer, year);
}

export function Dashboards_Nokia_ClaimsByOpponent(insurer, year) {
    return nokiaDashboard("/Dashboards/Nokia/ClaimsByOpponent", insurer, year);
}

export function Dashboards_Nokia_OpenVsClosed(insurer) {
    return nokiaDashboard("/Dashboards/Nokia/OpenVsClosed", insurer, undefined);
}

export function Dashboards_Nokia_PaidAndOutstanding(insurer) {
    return nokiaDashboard("/Dashboards/Nokia/PaidAndOutstanding", insurer, undefined);
}

export function Dashboards_Nokia_ClaimValues(insurer) {
    return nokiaDashboard("/Dashboards/Nokia/ClaimValues", insurer, undefined);
}

export function Dashboards_Nokia_DaysFromAdviceToSettlement(insurer) {
    return nokiaDashboard("/Dashboards/Nokia/DaysFromAdviceToSettlement", insurer, undefined);
}

export function Dashboards_Nokia_CauseOfLoss(insurer) {
    return nokiaDashboard("/Dashboards/Nokia/CauseOfLoss", insurer, undefined);
}

export function Dashboards_Nokia_ClaimsByMonth(insurer, year) {
    return nokiaDashboard("/Dashboards/Nokia/ClaimsByMonth", insurer, year);
}

export function Dashboards_Nokia_BiggestClaims(insurer, year) {
    return nokiaDashboard("/Dashboards/Nokia/BiggestClaims", insurer, year);
}

function nestleServiceLevel(url, startDate, endDate, groupId, country, insured, openPolicyNumber) {
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);
    url = url + "&groupId=" + encodeURIComponent(groupId);
    url = url + "&country=" + encodeURIComponent(country);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&openPolicyNumber=" + encodeURIComponent(openPolicyNumber);

    return url;
}

export function Dashboards_Nestle_Kpi1_1(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi1_1", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_Kpi2_1(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi2_1", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_Kpi2_2(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi2_2", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_Kpi2_3(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi2_3", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_Kpi2_4(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi2_4", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_Kpi2_5(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi2_5", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_Kpi2_6(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi2_6", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_Kpi3_1(startDate, endDate, groupId, country, insured, openPolicyNumber) {
    return nestleServiceLevel("/Dashboards/Nestle/Kpi3_1", startDate, endDate, groupId, country, insured, openPolicyNumber);
}

export function Dashboards_Nestle_ZoneList() {
    var url = "/Dashboards/Nestle/ZoneList";

    return url;
}

export function Dashboards_Nestle_CountryList() {
    var url = "/Dashboards/Nestle/CountryList";

    return url;
}

export function Dashboards_Nestle_PolicyYearList() {
    var url = "/Dashboards/Nestle/PolicyYearList";

    return url;
}

export function Dashboards_TtClub_InsuredList() {
    var url = "/Dashboards/TtClub/InsuredList";

    return url;
}

function ttClubDashboard(url, insured, oec, year) {
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&oec=" + encodeURIComponent(oec);

    if (year) {
        url = url + "&year=" + encodeURIComponent(year);
    }

    return url;
}

export function Dashboards_TtClub_YearList(insured, oec) {
    return ttClubDashboard("/Dashboards/TtClub/YearList", insured, oec);
}

export function Dashboards_TtClub_OpenVsClosed(insured, oec) {
    return ttClubDashboard("/Dashboards/TtClub/OpenVsClosed", insured, oec);
}

export function Dashboards_TtClub_PaidAndOutstanding(insured, oec) {
    return ttClubDashboard("/Dashboards/TtClub/PaidAndOutstanding", insured, oec);
}

export function Dashboards_TtClub_ClaimValues(insured, oec) {
    return ttClubDashboard("/Dashboards/TtClub/ClaimValues", insured, oec);
}

export function Dashboards_TtClub_DaysFromAdviceToSettlement(insured, oec) {
    return ttClubDashboard("/Dashboards/TtClub/DaysFromAdviceToSettlement", insured, oec);
}

export function Dashboards_TtClub_CauseOfLoss(insured, oec) {
    return ttClubDashboard("/Dashboards/TtClub/CauseOfLoss", insured, oec);
}

export function Dashboards_TtClub_NewClaimsByMonth(insured, oec) {
    return ttClubDashboard("/Dashboards/TtClub/NewClaimsByMonth", insured, oec);
}

export function Dashboards_TtClub_BiggestClaims(insured, oec, year) {
    return ttClubDashboard("/Dashboards/TtClub/BiggestClaims", insured, oec, year);
}

export function Dashboards_TtClub_ClaimOpponents(insured, oec, year) {
    return ttClubDashboard("/Dashboards/TtClub/ClaimOpponents", insured, oec, year);
}

export function Documents_Document_ListDocuments(documentType, caseId) {
    var url = "/Documents/Document/ListDocuments";
    url = url + "?documentType=" + encodeURIComponent(documentType);
    url = url + "&caseId=" + encodeURIComponent(caseId);

    return url;
}

export function Documents_Document_DownloadDocument(documentName) {
    var url = "/Documents/Document/DownloadDocument";
    url = url + "?documentName=" + encodeURIComponent(documentName);

    return url;
}

export function Documents_Document_UploadDocument(caseId, documentType, friendlyName) {
    var url = "/Documents/Document/UploadDocument";
    url = url + "?caseId=" + caseId;
    url = url + "&documentType=" + encodeURIComponent(documentType);
    url = url + "&friendlyName=" + encodeURIComponent(friendlyName);

    return url;
}

export function Documents_Document_GetDocumentTypes() {
    var url = "/Documents/Document/GetDocumentTypes";

    return url;
}

export function Documents_Document_DeleteDocument(documentId) {
    var url = "/Documents/Document/DeleteDocument";
    url = url + "?documentId=" + encodeURIComponent(documentId);

    return url;
}

export function Dashboards_Rsa_InsuranceYearList() {
    var url = "/Dashboards/Rsa/InsuranceYearList";

    return url;
}

export function Dashboards_Rsa_OpenVsClosed() {
    var url = "/Dashboards/Rsa/OpenVsClosed";

    return url;
}

export function Dashboards_Rsa_PaidAndOutstanding() {
    var url = "/Dashboards/Rsa/PaidAndOutstanding";

    return url;
}

export function Dashboards_Rsa_ClaimValues() {
    var url = "/Dashboards/Rsa/ClaimValues";

    return url;
}

export function Dashboards_Rsa_DaysFromAdviceToSettlement() {
    var url = "/Dashboards/Rsa/DaysFromAdviceToSettlement";

    return url;
}

export function Dashboards_Rsa_CauseOfLoss() {
    var url = "/Dashboards/Rsa/CauseOfLoss";

    return url;
}

export function Dashboards_Rsa_ClaimsByMonth() {
    var url = "/Dashboards/Rsa/ClaimsByMonth";

    return url;
}

export function Dashboards_Rsa_ClaimsByOffice(year) {
    var url = "/Dashboards/Rsa/ClaimsByOffice";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Rsa_BiggestClaims(year) {
    var url = "/Dashboards/Rsa/BiggestClaims";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Rsa_ClaimsByLsp(year) {
    var url = "/Dashboards/Rsa/ClaimsByLsp";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Rsa_OfficeList() {
    var url = "/Dashboards/Rsa/OfficeList";

    return url;
}

export function Dashboards_Rsa_YearList() {
    var url = "/Dashboards/Rsa/YearList";

    return url;
}

export function Dashboards_Rsa_InsuredList() {
    var url = "/Dashboards/Rsa/InsuredList";

    return url;
}

function rsaDashboard(url, year, office, insuredId) {
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&office=" + encodeURIComponent(office);
    url = url + "&insuredId=" + encodeURIComponent(insuredId);
    
    return url;
}

export function Dashboards_Rsa_RecoveryAmountByYear(year, office, insuredId, successfulOnly) {
    var url = "/Dashboards/Rsa/RecoveryAmountByYear";
    url = rsaDashboard(url, year, office, insuredId);
    url = url + "&successfulOnly=" + encodeURIComponent(successfulOnly);

    return url;
}

export function Dashboards_Rsa_ClaimsSummary(year, office, insuredId) {
    var url = "/Dashboards/Rsa/ClaimsSummary";

    return rsaDashboard(url, year, office, insuredId);
}

export function Dashboards_Rsa_RecoveryAmountsByTransport(year, office, insuredId) {
    var url = "/Dashboards/Rsa/RecoveryAmountsByTransport";

    return rsaDashboard(url, year, office, insuredId);
}
export function Dashboards_Rsa_ClaimValueAmounts(year, office, insuredId) {
    var url = "/Dashboards/Rsa/ClaimValueAmounts";

    return rsaDashboard(url, year, office, insuredId);
}

export function Dashboards_Rsa_ClaimsByOpponent(year, office, insuredId) {
    var url = "/Dashboards/Rsa/ClaimsByOpponent";

    return rsaDashboard(url, year, office, insuredId);
}

export function Dashboards_Rsa_ReasonsForNoRecovery(year, office, insuredId) {
    var url = "/Dashboards/Rsa/ReasonsForNoRecovery";

    return rsaDashboard(url, year, office, insuredId);
}

export function Standard_SantaFe_GetSantaFe(id) {
    var url = "/Standard/SantaFe/GetSantaFe";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function Standard_SantaFe_UpdateSantaFe() {
    var url = "/Standard/SantaFe/UpdateSantaFe";

    return url;
}

export function Standard_SantaFe_NatureOfLoss() {
    var url = "/Standard/SantaFe/NatureOfLoss";

    return url;
}

export function Standard_SantaFe_Currency() {
    var url = "/Standard/SantaFe/Currency";

    return url;
}

export function Standard_SantaFe_Country() {
    var url = "/Standard/SantaFe/Country";

    return url;
}

export function Standard_SantaFe_ClaimHandler() {
    var url = "/Standard/SantaFe/ClaimHandler";

    return url;
}

export function Standard_SantaFe_Office() {
    var url = "/Standard/SantaFe/Office";

    return url;
}

export function Standard_SantaFe_Account() {
    var url = "/Standard/SantaFe/Account";

    return url;
}

export function Standard_SantaFe_Period() {
    var url = "/Standard/SantaFe/Period";

    return url;
}

export function Standard_SantaFe_ClaimStatus() {
    var url = "/Standard/SantaFe/ClaimStatus";

    return url;
}

export function Standard_SantaFe_TransferClaim(caseId, reason, comments, password) {
    var url = "/Standard/SantaFe/TransferClaim";
    url = url + "?caseId=" + encodeURIComponent(caseId),
        url = url + "&reason=" + encodeURIComponent(reason);
    url = url + "&comments=" + encodeURIComponent(comments);
    url = url + "&password=" + encodeURIComponent(password);

    return url;
}

export function Standard_SantaFe_MakePayment(password) {
    var url = "/Standard/SantaFe/MakePayment";
    url = url + "?password=" + encodeURIComponent(password);

    return url;
}


export function WellsFargo_Home_InsurerList(prefix) {
    var url = "/WellsFargo/Home/InsurerList";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function WellsFargo_Home_InsuredList(prefix, search) {
    var url = "/WellsFargo/Home/InsuredList";
    url = url + "?prefix=" + encodeURIComponent(prefix);
    url = url + "&search=" + encodeURIComponent(search);

    return url;
}

export function WellsFargo_Home_CaseList(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/WellsFargo/Home/CaseList";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function WellsFargo_Home_DownloadCaseReport(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix) {
    var url = "/WellsFargo/Home/DownloadCaseReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);

    return url;
}

function wellsFargoDashboard(url, insurer, insured, startDate, endDate) {
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Dashboards_WellsFargo_InsurerList() {
    var url = "/Dashboards/WellsFargo/InsurerList";

    return url;
}

export function Dashboards_WellsFargo_InsuredList(insurer) {
    var url = "/Dashboards/WellsFargo/InsuredList";
    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Dashboards_WellsFargo_OpenVsClosed(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/OpenVsClosed", insurer, insured, startDate, endDate);
}

export function Dashboards_WellsFargo_PaidAndOutstanding(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/PaidAndOutstanding", insurer, insured, startDate, endDate);
}

export function Dashboards_WellsFargo_ClaimValues(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/ClaimValues", insurer, insured, startDate, endDate);
}

export function Dashboards_WellsFargo_DaysFromAdviceToSettlement(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/DaysFromAdviceToSettlement", insurer, insured, startDate, endDate);
}

export function Dashboards_WellsFargo_CauseOfLoss(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/CauseOfLoss", insurer, insured, startDate, endDate);
}

export function Dashboards_WellsFargo_NewClaimsByMonth(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/NewClaimsByMonth", insurer, insured, startDate, endDate);
}

export function Dashboards_WellsFargo_BiggestClaims(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/BiggestClaims", insurer, insured, startDate, endDate);
}

export function Dashboards_WellsFargo_ClaimOpponents(insurer, insured, startDate, endDate) {
    return wellsFargoDashboard("/Dashboards/WellsFargo/ClaimOpponents", insurer, insured, startDate, endDate);
}


export function Unirisc_Home_InsurerList(prefix) {
    var url = "/Unirisc/Home/InsurerList";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function Unirisc_Home_InsuredList(prefix, search) {
    var url = "/Unirisc/Home/InsuredList";
    url = url + "?prefix=" + encodeURIComponent(prefix);
    url = url + "&search=" + encodeURIComponent(search);

    return url;
}

export function Unirisc_Home_CaseList(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/Unirisc/Home/CaseList";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function Unirisc_Home_DownloadCaseReport(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix) {
    var url = "/Unirisc/Home/DownloadCaseReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);

    return url;
}

function uniriscDashboard(url, insurer, insured, startDate, endDate) {
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Dashboards_Unirisc_InsurerList() {
    var url = "/Dashboards/Unirisc/InsurerList";

    return url;
}

export function Dashboards_Unirisc_InsuredList(insurer) {
    var url = "/Dashboards/Unirisc/InsuredList";
    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Dashboards_Unirisc_OpenVsClosed(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/OpenVsClosed", insurer, insured, startDate, endDate);
}

export function Dashboards_Unirisc_PaidAndOutstanding(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/PaidAndOutstanding", insurer, insured, startDate, endDate);
}

export function Dashboards_Unirisc_ClaimValues(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/ClaimValues", insurer, insured, startDate, endDate);
}

export function Dashboards_Unirisc_DaysFromAdviceToSettlement(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/DaysFromAdviceToSettlement", insurer, insured, startDate, endDate);
}

export function Dashboards_Unirisc_CauseOfLoss(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/CauseOfLoss", insurer, insured, startDate, endDate);
}

export function Dashboards_Unirisc_NewClaimsByMonth(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/NewClaimsByMonth", insurer, insured, startDate, endDate);
}

export function Dashboards_Unirisc_BiggestClaims(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/BiggestClaims", insurer, insured, startDate, endDate);
}

export function Dashboards_Unirisc_ClaimOpponents(insurer, insured, startDate, endDate) {
    return uniriscDashboard("/Dashboards/Unirisc/ClaimOpponents", insurer, insured, startDate, endDate);
}

export function Dashboards_Wwe_InsuranceYearList() {
    var url = "/Dashboards/Wwe/InsuranceYearList";

    return url;
}

export function Dashboards_Wwe_OpenVsClosed() {
    var url = "/Dashboards/Wwe/OpenVsClosed";

    return url;
}

export function Dashboards_Wwe_PaidAndOutstanding() {
    var url = "/Dashboards/Wwe/PaidAndOutstanding";

    return url;
}

export function Dashboards_Wwe_ClaimValues() {
    var url = "/Dashboards/Wwe/ClaimValues";

    return url;
}

export function Dashboards_Wwe_ClaimsByCommodity(year) {
    var url = "/Dashboards/Wwe/ClaimsByCommodity";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Wwe_ClaimsByInsured(year) {
    var url = "/Dashboards/Wwe/ClaimsByInsured";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Wwe_ClaimsByCommodityReport(year) {
    var url = "/Dashboards/Wwe/ClaimsByCommodityReport";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Wwe_ClaimsByInsuredReport(year) {
    var url = "/Dashboards/Wwe/ClaimsByInsuredReport";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Wwe_DaysFromAdviceToSettlement() {
    var url = "/Dashboards/Wwe/DaysFromAdviceToSettlement";

    return url;
}

export function Dashboards_Wwe_CauseOfLoss() {
    var url = "/Dashboards/Wwe/CauseOfLoss";

    return url;
}

export function Dashboards_Wwe_ClaimsByOffice(year) {
    var url = "/Dashboards/Wwe/ClaimsByOffice";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Wwe_ClaimsByMonth() {
    var url = "/Dashboards/Wwe/ClaimsByMonth";

    return url;
}

export function Dashboards_Wwe_BiggestClaims(year) {
    var url = "/Dashboards/Wwe/BiggestClaims";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Wwe_ClaimsByLsp(year) {
    var url = "/Dashboards/Wwe/ClaimsByLsp";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Wwe_OfficeList() {
    var url = "/Dashboards/Wwe/OfficeList";

    return url;
}

export function Dashboards_Wwe_YearList() {
    var url = "/Dashboards/Wwe/YearList";

    return url;
}

export function Dashboards_Wwe_InsuredList() {
    var url = "/Dashboards/Wwe/InsuredList";

    return url;
}

function wweDashboard(url, year, office, insuredId) {
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&office=" + encodeURIComponent(office);
    url = url + "&insuredId=" + encodeURIComponent(insuredId);

    return url;
}

export function Dashboards_Wwe_RecoveryAmountByYear(year, office, insuredId, successfulOnly) {
    var url = "/Dashboards/Wwe/RecoveryAmountByYear";
    url = wweDashboard(url, year, office, insuredId);
    url = url + "&successfulOnly=" + encodeURIComponent(successfulOnly);

    return url;
}

export function Dashboards_Wwe_ClaimsSummary(year, office, insuredId) {
    var url = "/Dashboards/Wwe/ClaimsSummary";

    return wweDashboard(url, year, office, insuredId);
}

export function Dashboards_Wwe_RecoveryAmountsByTransport(year, office, insuredId) {
    var url = "/Dashboards/Wwe/RecoveryAmountsByTransport";

    return wweDashboard(url, year, office, insuredId);
}
export function Dashboards_Wwe_ClaimValueAmounts(year, office, insuredId) {
    var url = "/Dashboards/Wwe/ClaimValueAmounts";

    return wweDashboard(url, year, office, insuredId);
}

export function Dashboards_Wwe_ClaimsByOpponent(year, office, insuredId) {
    var url = "/Dashboards/Wwe/ClaimsByOpponent";

    return wweDashboard(url, year, office, insuredId);
}

export function Dashboards_Wwe_ReasonsForNoRecovery(year, office, insuredId) {
    var url = "/Dashboards/Wwe/ReasonsForNoRecovery";

    return wweDashboard(url, year, office, insuredId);
}

function santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    url = url + "?registeredFrom=" + encodeURIComponent(registeredFrom);
    url = url + "&registeredTo=" + encodeURIComponent(registeredTo);
    url = url + "&submittedFrom=" + encodeURIComponent(submittedFrom);
    url = url + "&submittedTo=" + encodeURIComponent(submittedTo);
    url = url + "&finalisedFrom=" + encodeURIComponent(finalisedFrom);
    url = url + "&finalisedTo=" + encodeURIComponent(finalisedTo);
    url = url + "&settledFrom=" + encodeURIComponent(settledFrom);
    url = url + "&settledTo=" + encodeURIComponent(settledTo);

    return url;
}

export function Dashboards_SantaFe_OpenVsClosed(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/OpenVsClosed";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_PaidAndOutstanding(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/PaidAndOutstanding";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_ClaimValues(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/ClaimValues";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_DaysFromClaimCompletedToSettlement(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/DaysFromClaimCompletedToSettlement";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_CauseOfLoss(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/CauseOfLoss";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_ClaimsByOffice(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/ClaimsByOffice";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_ClaimsByMonth(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/ClaimsByMonth";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_BiggestClaims(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/BiggestClaims";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

export function Dashboards_SantaFe_ClaimsByCorporateAccount(registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo) {
    var url = "/Dashboards/SantaFe/ClaimsByCorporateAccount";

    return santaFeDashboard(url, registeredFrom, registeredTo, submittedFrom, submittedTo, finalisedFrom, finalisedTo, settledFrom, settledTo);
}

function nestleDashboard(url, year) {
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Nestle_OpenVsClosed() {
    var url = "/Dashboards/Nestle/OpenVsClosed";

    return url;
}

export function Dashboards_Nestle_PaidAndOutstanding() {

    var url = "/Dashboards/Nestle/PaidAndOutstanding";

    return url;
}

export function Dashboards_Nestle_ClaimValues() {

    var url = "/Dashboards/Nestle/ClaimValues";

    return url;
}

export function Dashboards_Nestle_DaysFromAdviceToSettlement() {
    var url = "/Dashboards/Nestle/DaysFromAdviceToSettlement";

    return url;
}


export function Dashboards_Nestle_CauseOfLoss() {
    var url = "/Dashboards/Nestle/CauseOfLoss";

    return url;
}


export function Dashboards_Nestle_ClaimsByMonth() {
    var url = "/Dashboards/Nestle/ClaimsByMonth";

    return url;
}

export function Dashboards_Nestle_BiggestClaims(year) {
    var url = nestleDashboard("/Dashboards/Nestle/BiggestClaims", year);

    return url;
}

export function Dashboards_Nestle_ClaimsByLsp(year) {
    var url = nestleDashboard("/Dashboards/Nestle/ClaimsByLsp", year);

    return url;
}

export function Dashboards_Nestle_YearList() {
    var url = "/Dashboards/Nestle/YearList";

    return url;
}


export function Dashboards_Nestle_RecoveryAmountByYear(year, successfulOnly) {
    var url = nestleDashboard("/Dashboards/Nestle/RecoveryAmountByYear", year);

    url = url + "&successfulOnly=" + successfulOnly;

    return url;
}

export function Dasboards_Nestle_ClaimsSummary(year) {
    var url = nestleDashboard("/Dashboards/Nestle/ClaimsSummary", year);

    return url;
}


export function Dashboards_Nestle_RecoveryAmountsByTransport(year) {
    var url = nestleDashboard("/Dashboards/Nestle/RecoveryAmountsByTransport", year);

    return url;
}

export function Dashboards_Nestle_ClaimValueAmounts(year) {
    var url = nestleDashboard("/Dashboards/Nestle/ClaimValueAmounts", year);

    return url;
}

export function Dashboards_Nestle_ReasonsForNoRecovery(year) {
    var url = nestleDashboard("/Dashboards/Nestle/ReasonsForNoRecovery", year);

    return url;
}

export function Standard_CustomReport_WellsFargoRmrGeneralReport() {
    var url = "/Standard/CustomReport/WellsFargoRmrGeneralReport";

    return url;
}

export function Standard_CustomReport_WellsFargoLossReportTrc(startDate, endDate) {
    var url = "/Standard/CustomReport/WellsFargoLossReportTrc";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_WellsFargoLossReportGeneric(insurer, insured, startDate, endDate) {
    var url = "/Standard/CustomReport/WellsFargoLossReportGeneric";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_WellsFargoRmrSummaryReport(insured, accountReference, startDate, endDate) {
    var url = "/Standard/CustomReport/WellsFargoRmrSummaryReport";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&accountReference=" + encodeURIComponent(accountReference);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_WellsFargoBankLossReport(insured, startDate, endDate) {
    var url = "/Standard/CustomReport/WellsFargoBankLossReport";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_CnaMarineLossReport(insured, startDate, endDate) {
    var url = "/Standard/CustomReport/CnaMarineLossReport";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_UniriscCnaMarineLossReport(insured, startDate, endDate) {
    var url = "/Standard/CustomReport/UniriscCnaMarineLossReport";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_WellsFargoRmrInsuredList() {
    var url = "/Standard/CustomReport/WellsFargoRmrInsuredList";

    return url;
}

export function Standard_CustomReport_WellsFargoRmrAccountReferenceList() {
    var url = "/Standard/CustomReport/WellsFargoRmrAccountReferenceList";

    return url;
}

export function Standard_CustomReport_WellsFargoInsurerList() {
    var url = "/Standard/CustomReport/WellsFargoInsurerList";

    return url;
}

export function Standard_CustomReport_WellsFargoInsuredList(insurer) {
    var url = "/Standard/CustomReport/WellsFargoInsuredList";
    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Standard_CustomReport_LamResearchLossRun() {
    var url = "/Standard/CustomReport/LamResearchLossRun";

    return url;
}

export function Standard_CustomReport_WellsFargoDndGeneralReport() {
    var url = "/Standard/CustomReport/WellsFargoDndGeneralReport";

    return url;
}

export function Standard_CustomReport_WellsFargoArpinGeneralReport() {
    var url = "/Standard/CustomReport/WellsFargoArpinGeneralReport";

    return url;
}

export function Standard_CustomReport_ZurichSubrogationSummary() {
    var url = "/Standard/CustomReport/ZurichSubrogationSummary";

    return url;
}

export function Standard_CustomReport_WweCommodityReport() {
    var url = "/Standard/CustomReport/WweCommodityReport";

    return url;
}

export function Standard_CustomReport_WweOfficeList() {
    var url = "/Standard/CustomReport/WweOfficeList";

    return url;
}

export function Standard_CustomReport_WweYearList() {
    var url = "/Standard/CustomReport/WweYearList";

    return url;
}

export function Standard_CustomReport_WweCustomerList() {
    var url = "/Standard/CustomReport/WweCustomerList";

    return url;
}


export function Standard_CustomReport_WweLossRunReport(year, office, customer, startDate, endDate, includeBlankDates) {
    var url = "/Standard/CustomReport/WweLossRunReport";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&office=" + encodeURIComponent(office);
    url = url + "&customer=" + encodeURIComponent(customer);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);
    url = url + "&includeBlankDates=" + encodeURIComponent(includeBlankDates);

    return url;
}

export function Standard_CustomReport_SugarSyndicateGeneralReport() {
    var url = "/Standard/CustomReport/SugarSyndicateGeneralReport";

    return url;
}

export function Standard_CustomReport_SunViewYearList() {
    var url = "/Standard/CustomReport/SunViewYearList";

    return url;
}

export function Standard_CustomReport_SunViewGeneralReport(year) {
    var url = "/Standard/CustomReport/SunViewGeneralReport";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_UrsInsuredReport() {
    var url = "/Standard/CustomReport/UrsInsuredReport";

    return url;
}

export function Standard_CustomReport_UrsPolicyReport() {
    var url = "/Standard/CustomReport/UrsPolicyReport";

    return url;
}


export function Standard_CustomReport_PhilipMorrisYearList() {
    var url = "/Standard/CustomReport/PhilipMorrisYearList";

    return url;
}

export function Standard_CustomReport_PhilipMorrisGroupList() {
    var url = "/Standard/CustomReport/PhilipMorrisGroupList";

    return url;
}

export function Standard_CustomReport_PhilipMorrisInsurerList() {
    var url = "/Standard/CustomReport/PhilipMorrisInsurerList";

    return url;
}

function philipMorrisCustomReport(url, year, group, groupName) {
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&groupName=" + encodeURIComponent(groupName);

    return url;
}

export function Standard_CustomReport_PhilipMorrisMonthlyReport(year, group, groupName, insurer) {
    var url = philipMorrisCustomReport("/Standard/CustomReport/PhilipMorrisMonthlyReport", year, group, groupName);
    url = url + "&insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Standard_CustomReport_PhilipMorrisTotalReport(year, group, groupName) {
    return philipMorrisCustomReport("/Standard/CustomReport/PhilipMorrisTotalReport", year, group, groupName);
}

export function Standard_CustomReport_PhilipMorrisLossFundReport(year, group, groupName) {
    return philipMorrisCustomReport("/Standard/CustomReport/PhilipMorrisLossFundReport", year, group, groupName);
}

export function Standard_CustomReport_PhilipMorrisExcessReport(year, group, groupName) {
    return philipMorrisCustomReport("/Standard/CustomReport/PhilipMorrisExcessReport", year, group, groupName);
}

export function Standard_CustomReport_BurnsAndWilcoxElectroline() {
    var url = "/Standard/CustomReport/BurnsAndWilcoxElectroline";

    return url;
}

export function Standard_CustomReport_BurnsAndWilcoxTransInsurers() {
    var url = "/Standard/CustomReport/BurnsAndWilcoxTransInsurers";

    return url;
}

export function Standard_CustomReport_BurnsAndWilcoxUniShippers() {
    var url = "/Standard/CustomReport/BurnsAndWilcoxUniShippers";

    return url;
}

export function Standard_CustomReport_TtClubInsuredList() {
    var url = "/Standard/CustomReport/TtClubInsuredList";

    return url;
}

export function Standard_CustomReport_TtClubMovementReport() {
    var url = "/Standard/CustomReport/TtClubMovementReport";

    return url;
}

export function Standard_CustomReport_TtClubSubrogationSummary() {
    var url = "/Standard/CustomReport/TtClubSubrogationSummary";

    return url;
}

export function Standard_CustomReport_TtClubLossRunReport(insured) {
    var url = "/Standard/CustomReport/TtClubLossRunReport";
    url = url + "?insured=" + encodeURIComponent(insured);

    return url;
}

export function Standard_CustomReport_TtClubFileHandledReport(startDate, endDate) {
    var url = "/Standard/CustomReport/TtClubFileHandledReport";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_UniriscRmrGeneralReport() {
    var url = "/Standard/CustomReport/UniriscRmrGeneralReport";

    return url;
}

export function Standard_CustomReport_UniriscLossReportTrc(startDate, endDate) {
    var url = "/Standard/CustomReport/UniriscLossReportTrc";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_UniriscLossReportGeneric(insurer, insured, startDate, endDate) {
    var url = "/Standard/CustomReport/UniriscLossReportGeneric";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_UniriscRmrSummaryReport(insured, accountReference, startDate, endDate) {
    var url = "/Standard/CustomReport/UniriscRmrSummaryReport";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&accountReference=" + encodeURIComponent(accountReference);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_UniriscBankLossReport(insured, startDate, endDate) {
    var url = "/Standard/CustomReport/UniriscBankLossReport";
    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_UniriscRmrInsuredList() {
    var url = "/Standard/CustomReport/UniriscRmrInsuredList";

    return url;
}

export function Standard_CustomReport_UniriscRmrAccountReferenceList() {
    var url = "/Standard/CustomReport/UniriscRmrAccountReferenceList";

    return url;
}

export function Standard_CustomReport_UniriscInsurerList() {
    var url = "/Standard/CustomReport/UniriscInsurerList";

    return url;
}

export function Standard_CustomReport_UniriscInsuredList(insurer) {
    var url = "/Standard/CustomReport/UniriscInsuredList";
    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Standard_CustomReport_UniriscDndGeneralReport() {
    var url = "/Standard/CustomReport/UniriscDndGeneralReport";

    return url;
}

export function Standard_CustomReport_UniriscArpinGeneralReport() {
    var url = "/Standard/CustomReport/UniriscArpinGeneralReport";

    return url;
}

export function Standard_CustomReport_NestleProgramList() {
    var url = "/Standard/CustomReport/NestleProgramList";

    return url;
}

export function Standard_CustomReport_NestlePolicyList() {
    var url = "/Standard/CustomReport/NestlePolicyList";

    return url;
}

export function Standard_CustomReport_NestleInsurerList() {
    var url = "/Standard/CustomReport/NestleInsurerList";

    return url;
}

export function Standard_CustomReport_NestleInsuredList() {
    var url = "/Standard/CustomReport/NestleInsuredList";

    return url;
}

export function Standard_CustomReport_NestleZoneList() {
    var url = "/Standard/CustomReport/NestleZoneList";

    return url;
}

export function Standard_CustomReport_NestleRegionList() {
    var url = "/Standard/CustomReport/NestleRegionList";

    return url;
}

export function Standard_CustomReport_NestleGeneralReport() {
    var url = "/Standard/CustomReport/NestleGeneralReport";

    return url;
}

export function Standard_CustomReport_Nestle2017UsageReport(startDate, endDate) {
    var url = "/Standard/CustomReport/Nestle2017UsageReport";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_NestleManagementInformationReport(program, policy, insurer, insured, zone, region, dateFrom, dateTo) {
    var url = "/Standard/CustomReport/NestleManagementInformationReport";
    url = url + "?program=" + encodeURIComponent(program);
    url = url + "&policy=" + encodeURIComponent(policy);
    url = url + "&insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&zone=" + encodeURIComponent(zone);
    url = url + "&region=" + encodeURIComponent(region);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);

    return url;
}

export function Standard_CustomReport_NestleKpiExpenseReport(startDate, endDate, zone, region, insured) {
    var url = "/Standard/CustomReport/NestleKpiExpenseReport";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);
    url = url + "&zone=" + encodeURIComponent(zone);
    url = url + "&region=" + encodeURIComponent(region);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Standard_CustomReport_NestleKpiTotalCostReport(zone, region, insured) {
    var url = "/Standard/CustomReport/NestleKpiTotalCostReport";
    url = url + "?zone=" + encodeURIComponent(zone);
    url = url + "&region=" + encodeURIComponent(region);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Standard_CustomReport_NestleKpiRecoveryReport(startDate, endDate, zone, region, insured) {
    var url = "/Standard/CustomReport/NestleKpiRecoveryReport";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);
    url = url + "&zone=" + encodeURIComponent(zone);
    url = url + "&region=" + encodeURIComponent(region);
    url = url + "&insured=" + encodeURIComponent(insured);

    return url;
}

export function Standard_CustomReport_WebReporterVisits(startDate, endDate) {
    var url = "/Standard/CustomReport/WebReporterVisits";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_Lookup_CompanyList() {
    var url = "/Standard/Lookup/CompanyList";

    return url;
}


function burnsAndWilcoxDashboard(url, cabId, year) {
    url = url + "?cabId=" + encodeURIComponent(cabId);

    if (year) {
        url = url + "&year=" + encodeURIComponent(year);
    }

    return url;
}

export function Dashboards_BurnsAndWilcox_YearList() {
    var url = "/Dashboards/BurnsAndWilcox/YearList";

    return url;
}

export function Dashboards_BurnsAndWilcox_OpenVsClosed(cabId) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/OpenVsClosed", cabId);

    return url;
}

export function Dashboards_BurnsAndWilcox_PaidAndOutstanding(cabId) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/PaidAndOutstanding", cabId);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimsByCommodity(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimsByCommodity", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimsByInsured(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimsByInsured", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimValues(cabId) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimValues", cabId);

    return url;
}

export function Dashboards_BurnsAndWilcox_DaysFromAdviceToSettlement(cabId) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/DaysFromAdviceToSettlement", cabId);

    return url;
}

export function Dashboards_BurnsAndWilcox_CauseOfLoss(cabId) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/CauseOfLoss", cabId);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimsByMonth(cabId) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimsByMonth", cabId);

    return url;
}


export function Dashboards_BurnsAndWilcox_BiggestClaims(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/BiggestClaims", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimsByLsp(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimsByLsp", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_RecoveryAmountByYear(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/RecoveryAmountByYear", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimsSummary(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimsSummary", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_RecoveryAmountsByTransport(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/RecoveryAmountsByTransport", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimValueAmounts(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimValueAmounts", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_ClaimsByOpponent(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ClaimsByOpponent", cabId, year);

    return url;
}

export function Dashboards_BurnsAndWilcox_ReasonsForNoRecovery(cabId, year) {
    var url = burnsAndWilcoxDashboard("/Dashboards/BurnsAndWilcox/ReasonsForNoRecovery", cabId, year);

    return url;
}

export function Standard_CustomReport_SantaFeGeneralReport(office, region, account, handler, claimStatus, openedFrom, openedTo, closedFrom, closedTo, amountFrom, amountTo) {
    var url = "/Standard/CustomReport/SantaFeGeneralReport";
    url = url + "?office=" + encodeURIComponent(office);
    url = url + "&region=" + encodeURIComponent(region);
    url = url + "&account=" + encodeURIComponent(account);
    url = url + "&handler=" + encodeURIComponent(handler);
    url = url + "&claimStatus=" + encodeURIComponent(claimStatus);
    url = url + "&openedFrom=" + encodeURIComponent(openedFrom);
    url = url + "&openedTo=" + encodeURIComponent(openedTo);
    url = url + "&closedFrom=" + encodeURIComponent(closedFrom);
    url = url + "&closedTo=" + encodeURIComponent(closedTo);
    url = url + "&amountFrom=" + encodeURIComponent(amountFrom);
    url = url + "&amountTo=" + encodeURIComponent(amountTo);

    return url;
}

export function Standard_CustomReport_SantaFeOfficeList() {
    var url = "/Standard/CustomReport/SantaFeOfficeList";

    return url;

}

export function Standard_CustomReport_SantaFeRegionList() {
    var url = "/Standard/CustomReport/SantaFeRegionList";

    return url;
}

export function Standard_CustomReport_SantaFeAccountList() {
    var url = "/Standard/CustomReport/SantaFeAccountList";

    return url;
}

export function Standard_CustomReport_SantaFeClaimStatusList() {
    var url = "/Standard/CustomReport/SantaFeClaimStatusList";

    return url;
}

export function Standard_CustomReport_SantaFeHandlerList() {
    var url = "/Standard/CustomReport/SantaFeHandlerList";

    return url;
}

export function Standard_CustomReport_MondelezTotalClaims(year, region) {
    var url = "/Standard/CustomReport/MondelezTotalClaims";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&region=" + encodeURIComponent(region);

    return url;
}

export function Standard_CustomReport_MondelezMonthlyReport(year, region) {
    var url = "/Standard/CustomReport/MondelezMonthlyReport";
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&region=" + encodeURIComponent(region);

    return url;
}

export function Standard_CustomReport_MondelezRegionList() {
    var url = "/Standard/CustomReport/MondelezRegionList";

    return url;
}

export function Standard_CustomReport_WiseReport() {
    var url = "/Standard/CustomReport/WiseReport";

    return url;
}

export function Standard_CustomReport_MsiMonthlyReport(month, year) {
    var url = "/Standard/CustomReport/MsiMonthlyReport";
    url = url + "?month=" + encodeURIComponent(month);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_UnitedIndiaQuarterlyReport(year) {
    var url = "/Standard/CustomReport/UnitedIndiaQuarterlyReport";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_JasRecoveryReport() {
    var url = "/Standard/CustomReport/JasRecoveryReport";

    return url;
}

export function Standard_CustomReport_UniCargoLossRatioReport() {
    var url = "/Standard/CustomReport/UniCargoLossRatioReport";

    return url;
}

export function Standard_CustomReport_RsaYearList() {
    var url = "/Standard/CustomReport/RsaYearList";

    return url;
}

export function Standard_CustomReport_RsaOfficeList() {
    var url = "/Standard/CustomReport/RsaOfficeList";

    return url;
}


export function Standard_CustomReport_RsaInsuredList() {
    var url = "/Standard/CustomReport/RsaInsuredList";

    return url;
}

function rsaLossRun(url, year, customer, office, dateFrom, dateTo, includeBlankDates) {
    url = url + "?year=" + encodeURIComponent(year);
    url = url + "&customer=" + encodeURIComponent(customer);
    url = url + "&office=" + encodeURIComponent(office);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);
    url = url + "&includeBlankDates=" + encodeURIComponent(includeBlankDates);

    return url;
}

export function Standard_CustomReport_RsaLossRun(url, year, customer, office, dateFrom, dateTo, includeBlankDates) {
    url = rsaLossRun("/Standard/CustomReport/RsaLossRun", url, year, customer, office, dateFrom, dateTo, includeBlankDates);

    return url;
}

export function Standard_CustomReport_RsaCustomerLossRun(url, year, customer, office, dateFrom, dateTo, includeBlankDates) {
    url = rsaLossRun("/Standard/CustomReport/RsaCustomerLossRun", url, year, customer, office, dateFrom, dateTo, includeBlankDates);

    return url;
}

export function Standard_CustomReport_RsaOpenClaimsSummaryReport(insurer, insured, registeredFrom, registeredTo) {
    var url = "/Standard/CustomReport/RsaOpenClaimsSummaryReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&registeredFrom=" + encodeURIComponent(registeredFrom);
    url = url + "&registeredTo=" + encodeURIComponent(registeredTo);

    return url;
}

export function Standard_CustomReport_RsaInsurerList() {
    var url = "/Standard/CustomReport/RsaInsurerList";

    return url;
}

export function Standard_CustomReport_GenericSubrogationSummary(insurer, insured, group) {
    var url = "/Standard/CustomReport/GenericSubrogationSummary";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&group=" + encodeURIComponent(group);

    return url;
}

export function Standard_CustomReport_InsurerList() {
    var url = "/Standard/CustomReport/InsurerList";

    return url;
}

export function Standard_CustomReport_GroupList() {
    var url = "/Standard/CustomReport/GroupList";

    return url;
}

export function Standard_CustomReport_InsuredList(search) {
    var url = "/Standard/CustomReport/InsuredList";
    url = url + "?search=" + encodeURIComponent(search);

    return url;
}

export function Standard_CustomReport_TalbotAnvMovementReport(insurer) {
    var url = "/Standard/CustomReport/TalbotAnvMovementReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Standard_CustomReport_TalbotAnvInsurerList() {
    var url = "/Standard/CustomReport/TalbotAnvInsurerList";

    return url;
}

export function Standard_CustomReport_AmazonPendingCargoClaims(dateOfLossFrom, dateOfLossTo, dateClaimReportedFrom, dateClaimReportedTo, causeOfLoss) {
    var url = "/Standard/CustomReport/AmazonPendingCargoClaims";
    url = url + "?dateOfLossFrom=" + encodeURIComponent(dateOfLossFrom);
    url = url + "&dateOfLossTo=" + encodeURIComponent(dateOfLossTo);
    url = url + "&dateClaimReportedFrom=" + encodeURIComponent(dateClaimReportedFrom);
    url = url + "&dateClaimReportedTo=" + encodeURIComponent(dateClaimReportedTo);
    url = url + "&causeOfLoss=" + encodeURIComponent(causeOfLoss);

    return url;
}

export function Standard_CustomReport_AmazonCauseOfLossList() {
    var url = "/Standard/CustomReport/AmazonCauseOfLossList";

    return url;
}

export function Standard_CustomReport_WellsFargoExpatRelocationsReport(insurer, startDate, endDate) {
    var url = "/Standard/CustomReport/WellsFargoExpatRelocationsReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_WellsFargoExpatRelocationsInsurerList() {
    var url = "/Standard/CustomReport/WellsFargoExpatRelocationsInsurerList";

    return url;
}

export function Standard_CustomReport_UniriscExpatRelocationsReport(insurer, startDate, endDate) {
    var url = "/Standard/CustomReport/UniriscExpatRelocationsReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_UniriscExpatRelocationsInsurerList() {
    var url = "/Standard/CustomReport/UniriscExpatRelocationsInsurerList";

    return url;
}


export function Standard_CustomReport_CnaSubroSummaryReport() {
    var url = "/Standard/CustomReport/CnaSubroSummaryReport";

    return url;
}

export function Standard_CustomReport_CnaSubroGeneralReport(insurer) {
    var url = "/Standard/CustomReport/CnaSubroGeneralReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);

    return url;
}

export function Standard_CustomReport_CnaSubroInsurerList() {
    var url = "/Standard/CustomReport/CnaSubroInsurerList";

    return url;
}

export function Standard_CustomReport_CnaCanadaReport(startDate, endDate) {
    var url = "/Standard/CustomReport/CnaCanadaReport";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_NokiaClaimsExperienceSummary() {
    var url = "/Standard/CustomReport/NokiaClaimsExperienceSummary";

    return url;
}

export function Standard_CustomReport_NestleQuarterlyFeeReport(startDate, endDate) {
    var url = "/Standard/CustomReport/NestleQuarterlyFeeReport";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_NestleQuarterlyFeeInternalReport(startDate, endDate) {
    var url = "/Standard/CustomReport/NestleQuarterlyFeeInternalReport";
    url = url + "?startDate=" + encodeURIComponent(startDate);
    url = url + "&endDate=" + encodeURIComponent(endDate);

    return url;
}

export function Standard_CustomReport_RsaCaseReport() {
    var url = "/Standard/CustomReport/RsaCaseReport";

    return url;
}


export function Standard_CustomReport_BritLossRun(insured) {
    var url = "/Standard/CustomReport/BritLossRun";
    url = url + "?insured=" + encodeURIComponent(insured);

    return url;
}


export function Standard_CustomReport_BritInsuredList() {
    var url = "/Standard/CustomReport/BritInsuredList";

    return url;
}


export function Standard_CustomReport_BritGeneralReport() {
    var url = "/Standard/CustomReport/BritGeneralReport";

    return url;
}


export function Standard_CustomReport_KraftFoodsTotalClaims(region, regionName, year) {
    var url = "/Standard/CustomReport/KraftFoodsTotalClaims";
    url = url + "?region=" + encodeURIComponent(region);
    url = url + "&regionName=" + encodeURIComponent(regionName);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}


export function Standard_CustomReport_KraftFoodsMonthlyClaims(region, regionName, year) {
    var url = "/Standard/CustomReport/KraftFoodsMonthlyClaims";
    url = url + "?region=" + encodeURIComponent(region);
    url = url + "&regionName=" + encodeURIComponent(regionName);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_KraftFoodsYearList() {
    var url = "/Standard/CustomReport/KraftFoodsYearList";

    return url;
}


export function Standard_CustomReport_KraftFoodsRegionList() {
    var url = "/Standard/CustomReport/KraftFoodsRegionList";

    return url;
}

export function Standard_CustomReport_AltriaTotalClaims(region, regionName, year) {
    var url = "/Standard/CustomReport/AltriaTotalClaims";
    url = url + "?region=" + encodeURIComponent(region);
    url = url + "&regionName=" + encodeURIComponent(regionName);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_AltriaLossFundClaims(region, regionName, year) {
    var url = "/Standard/CustomReport/AltriaLossFundClaims";
    url = url + "?region=" + encodeURIComponent(region);
    url = url + "&regionName=" + encodeURIComponent(regionName);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_AltriaExcessClaims(region, regionName, year) {
    var url = "/Standard/CustomReport/AltriaExcessClaims";
    url = url + "?region=" + encodeURIComponent(region);
    url = url + "&regionName=" + encodeURIComponent(regionName);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_AltriaMonthlyClaims(region, regionName, year) {
    var url = "/Standard/CustomReport/AltriaMonthlyClaims";
    url = url + "?region=" + encodeURIComponent(region);
    url = url + "&regionName=" + encodeURIComponent(regionName);
    url = url + "&year=" + encodeURIComponent(year);

    return url;
}

export function Standard_CustomReport_AltriaYearList() {
    var url = "/Standard/CustomReport/AltriaYearList";

    return url;
}


export function Standard_CustomReport_AltriaRegionList() {
    var url = "/Standard/CustomReport/AltriaRegionList";

    return url;
}

export function Standard_NewCharts_InsurerTreeMap() {
    var url = "/Standard/NewCharts/InsurerTreeMap";

    return url;
}

export function Dashboards_Convoy_OpenVsClosed() {
    var url = "/Dashboards/Convoy/OpenVsClosed";

    return url;
}

export function Dashboards_Convoy_PaidAndOutstanding() {
    var url = "/Dashboards/Convoy/PaidAndOutstanding";

    return url;
}

export function Dashboards_Convoy_ClaimValues() {
    var url = "/Dashboards/Convoy/ClaimValues";

    return url;
}

export function Dashboards_Convoy_DaysFromAdviceToClosed() {
    var url = "/Dashboards/Convoy/DaysFromAdviceToClosed";

    return url;
}

export function Dashboards_Convoy_CauseOfLoss() {
    var url = "/Dashboards/Convoy/CauseOfLoss";

    return url;
}

export function Dashboards_Convoy_BiggestClaims(year) {
    var url = "/Dashboards/Convoy/BiggestClaims";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Convoy_ClaimsByLsp(year) {
    var url = "/Dashboards/Convoy/ClaimsByLsp";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}

export function Dashboards_Convoy_InsuranceYearList() {
    var url = "/Dashboards/Convoy/InsuranceYearList";

    return url;
}

export function Dashboards_Convoy_ConvoyCarrierLiability(open) {
    var url = "/Dashboards/Convoy/ConvoyCarrierLiability";
    url = url + "?open=" + encodeURIComponent(open);

    return url;
}

export function Dashboards_Convoy_ConvoyLiabilityAndUninsuredPayments() {
    var url = "/Dashboards/Convoy/ConvoyLiabilityAndUninsuredPayments";

    return url;
}

export function Standard_CustomReport_ConvoyGeneralReport() {
    var url = "/Standard/CustomReport/ConvoyGeneralReport";

    return url;
}
export function Standard_CustomReport_DiageoGeneralReport() {
    var url = "/Standard/CustomReport/DiageoGeneralReport";

    return url;
}
export function Standard_CustomReport_ABCGeneralReport() {
    var url = "/Standard/CustomReport/ABCGeneralReport";

    return url;
}
export function Standard_CustomReport_DysonGeneralReport(year) {
    var url = "/Standard/CustomReport/DysonGeneralReport";
    url = url + "?year=" + encodeURIComponent(year);

    return url;
}
export function Standard_CustomReport_DysonYearList() {
    var url = "/Standard/CustomReport/DysonYearList";

    return url;
}

export function Admin_ErrorLog_GetErrorList(userId, dateFrom, dateTo, application, search, orderBy, orderAsc, pageSize, pageNumber) {
    var url = "/Admin/ErrorLog/GetErrorList";
    url = url + "?userId=" + encodeURIComponent(userId);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);
    url = url + "&application=" + encodeURIComponent(application);
    url = url + "&search=" + encodeURIComponent(search);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);

    return url;
}

/*
 * Diageo URLS
 */
export function Diageo_NewClaim_RegisterClaim(setPassword, email) {
    var url = "/Diageo/NewClaim/RegisterClaim";
    url = url + "?setPassword=" + setPassword;
    url = url + "&email=" + email;

    return url;
}

export function Diageo_Case_GetCase(id) {
    var url = "/Diageo/Case/GetCase";

    url = url + "?id=" + id;

    return url;
}

export function Diageo_Home_InsuredList() {
    var url = "/Diageo/Home/InsuredList";

    return url;
}

export function Diageo_Home_InsurerList() {
    var url = "/Diageo/Home/InsurerList";

    return url;
}

export function Diageo_Home_WkwReferenceList(match) {
    var url = "/Diageo/Home/WkwReferenceList";
    url = url + "?match=" + match;

    return url;
}

export function Diageo_Home_ClientReferenceList(match) {
    var url = "/Diageo/Home/ClientReferenceList";
    url = url + "?match=" + match;

    return url;
}

export function Diageo_Home_CaseList(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/Diageo/Home/CaseList";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function Diageo_Home_DownloadCaseReport(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix) {
    var url = "/Diageo/Home/DownloadCaseReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);

    return url;
}

function DiageoDashboard(url, insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    //url = url + "?insured=" + insured;
    //url = url + "&insurer=" + insurer;
    //url = url + "&claimDateFrom=" + claimDateFrom;
    //url = url + "&claimDateTo=" + claimDateTo;
    //url = url + "&shipDateFrom=" + shipDateFrom;
    //url = url + "&shipDateTo=" + shipDateTo;
    //url = url + "&closedDateFrom=" + closedDateFrom;
    //url = url + "&closedDateTo=" + closedDateTo;
    //url = url + "&policyNumber=" + policyNumber;
    //url = url + "&status=" + status;

    return url;
}


export function Dashboards_Diageo_OpenVsClosed(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/OpenVsClosed",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Diageo_PaidAndOutstanding(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/PaidAndOutstanding",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_CauseOfLoss(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/CauseOfLoss",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_ClaimsByMonth(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/ClaimsByMonth",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_ClaimValues(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/ClaimValues",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_DaysFromAdviceToSettlement(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/DaysFromAdviceToSettlement",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_BiggestClaims(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/BiggestClaims",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_RecoveriesByYear(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status, successfulOnly) {

    var url = DiageoDashboard("/Dashboards/Diageo/RecoveriesByYear",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    //url = url + "&successfulOnly=" + successfulOnly;
    url = url + "?successfulOnly=" + successfulOnly;

    return url;
}

export function Dashboards_Diageo_ClaimsSummary(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/ClaimsSummary",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Diageo_ReasonsForNoRecovery(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/ReasonsForNoRecovery",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_ClaimValueAmounts(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/ClaimValueAmounts",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Diageo_ClaimsByOpponent(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = DiageoDashboard("/Dashboards/Diageo/ClaimsByOpponent",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Standard_CustomReport_DiageoReport() {
    var url = "/Diageo/CustomReport/DiageoReport";

    return url;
}

export function Standard_Diageo_Email(caseid, text) {
    var url = "/Diageo/Case/SendEmail";
    url = url + "?wkwreference=" + encodeURIComponent(caseid);
    url = url + "&text=" + encodeURIComponent(text);

    return url;
}

// Diageo report

export function Diageo_Report_AllCasesReport() {
    var url = "/Diageo/Report/AllCasesReport";

    return url;
}

export function Diageo_Report_AllOpenCasesReport() {
    var url = "/Diageo/Report/AllOpenCasesReport";

    return url;
}

export function Diageo_Report_OpenCargoReport() {
    var url = "/Diageo/Report/OpenCargoReport";

    return url;
}

export function Diageo_Report_OpenRecoveriesReport() {
    var url = "/Diageo/Report/OpenRecoveriesReport";

    return url;
}

export function Diageo_Report_ConcludedRecoveriesReport() {
    var url = "/Diageo/Report/ConcludedRecoveriesReport";

    return url;
}

export function DiageoGeneralReport(url, group, prefix, insurer, insured, dateFrom, dateTo) {
    url = url + "?group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);

    return url;
}

export function Diageo_Report_GetUserAccess() {
    var url = "/Diageo/Report/GetUserAccess";

    return url;
}

export function Diageo_Report_GetGroupList() {
    var url = "/Diageo/Report/GetGroupList";

    return url;
}

export function Diageo_Home_InsuredCount(prefix) {
    var url = "/Diageo/Home/InsuredCount";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function Diageo_Home_CasePrefixList() {
    var url = "/Diageo/Home/CasePrefixList";

    return url;
}
export function Dashboards_MSIG_OpponentList() {
    var url = "/Dashboards/MSIG/OpponentList";

    return url;
}

function MSIGDashboard(url, insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    //url = url + "?insured=" + insured;
    //url = url + "&insurer=" + insurer;
    //url = url + "&claimDateFrom=" + claimDateFrom;
    //url = url + "&claimDateTo=" + claimDateTo;
    //url = url + "&shipDateFrom=" + shipDateFrom;
    //url = url + "&shipDateTo=" + shipDateTo;
    //url = url + "&closedDateFrom=" + closedDateFrom;
    //url = url + "&closedDateTo=" + closedDateTo;
    //url = url + "&policyNumber=" + policyNumber;
    //url = url + "&status=" + status;

    return url;
}


export function Dashboards_MSIG_OpenVsClosed(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/OpenVsClosed",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_MSIG_PaidAndOutstanding(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/PaidAndOutstanding",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_CauseOfLoss(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/CauseOfLoss",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_ClaimsByMonth(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/ClaimsByMonth",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_ClaimValues(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/ClaimValues",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_DaysFromAdviceToSettlement(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/DaysFromAdviceToSettlement",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_BiggestClaims(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/BiggestClaims",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_RecoveriesByYear(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status, successfulOnly) {

    var url = MSIGDashboard("/Dashboards/MSIG/RecoveriesByYear",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    //url = url + "&successfulOnly=" + successfulOnly;
    url = url + "?successfulOnly=" + successfulOnly;

    return url;
}

export function Dashboards_MSIG_ClaimsSummary(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/ClaimsSummary",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_MSIG_ReasonsForNoRecovery(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/ReasonsForNoRecovery",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_ClaimValueAmounts(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/ClaimValueAmounts",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_MSIG_ClaimsByOpponent(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = MSIGDashboard("/Dashboards/MSIG/ClaimsByOpponent",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Standard_CustomReport_MSIGReport() {
    var url = "/MSIG/CustomReport/MSIGReport";

    return url;
}
export function MSIG_Home_InsurerList() {
    var url = "/Dashboards/MSIG/InsurerList";

    return url;
}
export function MSIG_Home_InsuredList() {
    var url = "/Dashboards/MSIG/InsuredList";

    return url;
}

export function Dashboards_Fenix_OpponentList() {
    var url = "/Dashboards/Fenix/OpponentList";

    return url;
}

function FenixDashboard(url, insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    //url = url + "?insured=" + insured;
    //url = url + "&insurer=" + insurer;
    //url = url + "&claimDateFrom=" + claimDateFrom;
    //url = url + "&claimDateTo=" + claimDateTo;
    //url = url + "&shipDateFrom=" + shipDateFrom;
    //url = url + "&shipDateTo=" + shipDateTo;
    //url = url + "&closedDateFrom=" + closedDateFrom;
    //url = url + "&closedDateTo=" + closedDateTo;
    //url = url + "&policyNumber=" + policyNumber;
    //url = url + "&status=" + status;

    return url;
}


export function Dashboards_Fenix_OpenVsClosed(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/OpenVsClosed",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Fenix_PaidAndOutstanding(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/PaidAndOutstanding",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_CauseOfLoss(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/CauseOfLoss",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_ClaimsByMonth(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/ClaimsByMonth",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_ClaimValues(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/ClaimValues",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_DaysFromAdviceToSettlement(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/DaysFromAdviceToSettlement",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_BiggestClaims(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/BiggestClaims",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_RecoveriesByYear(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status, successfulOnly) {

    var url = FenixDashboard("/Dashboards/Fenix/RecoveriesByYear",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    //url = url + "&successfulOnly=" + successfulOnly;
    url = url + "?successfulOnly=" + successfulOnly;

    return url;
}

export function Dashboards_Fenix_ClaimsSummary(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/ClaimsSummary",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Fenix_ReasonsForNoRecovery(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/ReasonsForNoRecovery",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_ClaimValueAmounts(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/ClaimValueAmounts",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Fenix_ClaimsByOpponent(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = FenixDashboard("/Dashboards/Fenix/ClaimsByOpponent",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Standard_CustomReport_FenixReport() {
    var url = "/Fenix/CustomReport/FenixReport";

    return url;
}
export function Fenix_Home_InsurerList() {
    var url = "/Dashboards/Fenix/InsurerList";

    return url;
}
export function Fenix_Home_InsuredList() {
    var url = "/Dashboards/Fenix/InsuredList";

    return url;
}


function DysonDashboard(url, year) {

    if (year) {
        url = url + "?year=" + encodeURIComponent(year);
    }

    return url;
}

export function Dashboards_Dyson_YearList() {
    var url = "/Dashboards/Dyson/YearList";

    return url;
}

export function Dashboards_Dyson_OpenVsClosed() {
    var url = DysonDashboard("/Dashboards/Dyson/OpenVsClosed");

    return url;
}

export function Dashboards_Dyson_PaidAndOutstanding() {
    var url = DysonDashboard("/Dashboards/Dyson/PaidAndOutstanding");

    return url;
}

export function Dashboards_Dyson_ClaimsByCommodity(year) {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimsByCommodity", year);

    return url;
}

export function Dashboards_Dyson_ClaimsByInsured(year) {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimsByInsured", year);

    return url;
}

export function Dashboards_Dyson_ClaimValues() {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimValues");

    return url;
}

export function Dashboards_Dyson_DaysFromAdviceToSettlement() {
    var url = DysonDashboard("/Dashboards/Dyson/DaysFromAdviceToSettlement");

    return url;
}

export function Dashboards_Dyson_CauseOfLoss() {
    var url = DysonDashboard("/Dashboards/Dyson/CauseOfLoss");

    return url;
}

export function Dashboards_Dyson_ClaimsByMonth() {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimsByMonth");

    return url;
}


export function Dashboards_Dyson_BiggestClaims(year) {
    var url = DysonDashboard("/Dashboards/Dyson/BiggestClaims", year);

    return url;
}

export function Dashboards_Dyson_ClaimsByLsp(year) {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimsByLsp", year);

    return url;
}

export function Dashboards_Dyson_RecoveryAmountByYear(year) {
    var url = DysonDashboard("/Dashboards/Dyson/RecoveryAmountByYear", year);

    return url;
}

export function Dashboards_Dyson_ClaimsSummary(year) {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimsSummary", year);

    return url;
}

export function Dashboards_Dyson_RecoveryAmountsByTransport(year) {
    var url = DysonDashboard("/Dashboards/Dyson/RecoveryAmountsByTransport", year);

    return url;
}

export function Dashboards_Dyson_ClaimValueAmounts(year) {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimValueAmounts", year);

    return url;
}

export function Dashboards_Dyson_ClaimsByOpponent(year) {
    var url = DysonDashboard("/Dashboards/Dyson/ClaimsByOpponent", year);

    return url;
}

export function Dashboards_Dyson_ReasonsForNoRecovery(year) {
    var url = DysonDashboard("/Dashboards/Dyson/ReasonsForNoRecovery", year);

    return url;
}

export function Standard_CustomReport_LoadSureLossRunReport(insured, treatyYear) {
    var url = "/Standard/CustomReport/LoadSureLossRunReport";

    url = url + "?insured=" + encodeURIComponent(insured);
    url = url + "&treatyYear=" + encodeURIComponent(treatyYear);

    return url;
}

export function Standard_CustomReport_LoadSureTreatyYearList() {
    var url = "/Standard/CustomReport/LoadSureTreatyYearList";

    return url;
}

export function Standard_CustomReport_LoadSureInsuredList() {
    var url = "/Standard/CustomReport/LoadSureInsuredList";

    return url;
}

export function Standard_CustomReport_NewIndiaGeneralReport() {
    var url = "/Standard/CustomReport/NewIndiaGeneralReport";

    return url;
}


/*
 * Amazon URLS
 */
export function Amazon_NewClaim_RegisterClaim(setPassword, email) {
    var url = "/Amazon/NewClaim/RegisterClaim";
    url = url + "?setPassword=" + setPassword;
    url = url + "&email=" + email;

    return url;
}

export function Amazon_Case_GetCase(id) {
    var url = "/Amazon/Case/GetCase";

    url = url + "?id=" + id;

    return url;
}

export function Amazon_Home_InsuredList() {
    var url = "/Amazon/Home/InsuredList";

    return url;
}

export function Amazon_Home_InsurerList() {
    var url = "/Amazon/Home/InsurerList";

    return url;
}

export function Amazon_Home_WkwReferenceList(match) {
    var url = "/Amazon/Home/WkwReferenceList";
    url = url + "?match=" + match;

    return url;
}

export function Amazon_Home_ClientReferenceList(match) {
    var url = "/Amazon/Home/ClientReferenceList";
    url = url + "?match=" + match;

    return url;
}

export function Amazon_Home_CaseList(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/Amazon/Home/CaseList";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function Amazon_Home_DownloadCaseReport(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix) {
    var url = "/Amazon/Home/DownloadCaseReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);

    return url;
}

function AmazonDashboard(url, insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    //url = url + "?insured=" + insured;
    //url = url + "&insurer=" + insurer;
    //url = url + "&claimDateFrom=" + claimDateFrom;
    //url = url + "&claimDateTo=" + claimDateTo;
    //url = url + "&shipDateFrom=" + shipDateFrom;
    //url = url + "&shipDateTo=" + shipDateTo;
    //url = url + "&closedDateFrom=" + closedDateFrom;
    //url = url + "&closedDateTo=" + closedDateTo;
    //url = url + "&policyNumber=" + policyNumber;
    //url = url + "&status=" + status;

    return url;
}


export function Dashboards_Amazon_OpenVsClosed(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/OpenVsClosed",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Amazon_PaidAndOutstanding(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/PaidAndOutstanding",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_CauseOfLoss(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/CauseOfLoss",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_ClaimsByMonth(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/ClaimsByMonth",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_ClaimValues(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/ClaimValues",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_DaysFromAdviceToSettlement(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/DaysFromAdviceToSettlement",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_BiggestClaims(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/BiggestClaims",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_RecoveriesByYear(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status, successfulOnly) {

    var url = AmazonDashboard("/Dashboards/Amazon/RecoveriesByYear",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    //url = url + "&successfulOnly=" + successfulOnly;
    url = url + "?successfulOnly=" + successfulOnly;

    return url;
}

export function Dashboards_Amazon_ClaimsSummary(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/ClaimsSummary",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Amazon_ReasonsForNoRecovery(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/ReasonsForNoRecovery",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_ClaimValueAmounts(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/ClaimValueAmounts",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Amazon_ClaimsByOpponent(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = AmazonDashboard("/Dashboards/Amazon/ClaimsByOpponent",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Standard_CustomReport_AmazonReport() {
    var url = "/Amazon/CustomReport/AmazonReport";

    return url;
}

export function Standard_Amazon_Email(caseid, text) {
    var url = "/Amazon/Case/SendEmail";
    url = url + "?wkwreference=" + encodeURIComponent(caseid);
    url = url + "&text=" + encodeURIComponent(text);

    return url;
}

// Amazon report

export function Amazon_Report_AllCasesReport() {
    var url = "/Amazon/Report/AllCasesReport";

    return url;
}

export function Amazon_Report_AllOpenCasesReport() {
    var url = "/Amazon/Report/AllOpenCasesReport";

    return url;
}

export function Amazon_Report_OpenCargoReport() {
    var url = "/Amazon/Report/OpenCargoReport";

    return url;
}

export function Amazon_Report_OpenRecoveriesReport() {
    var url = "/Amazon/Report/OpenRecoveriesReport";

    return url;
}

export function Amazon_Report_ConcludedRecoveriesReport() {
    var url = "/Amazon/Report/ConcludedRecoveriesReport";

    return url;
}

export function AmazonGeneralReport(url, group, prefix, insurer, insured, dateFrom, dateTo) {
    url = url + "?group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);

    return url;
}

export function Amazon_Report_GetUserAccess() {
    var url = "/Amazon/Report/GetUserAccess";

    return url;
}

export function Amazon_Report_GetGroupList() {
    var url = "/Amazon/Report/GetGroupList";

    return url;
}

export function Amazon_Home_InsuredCount(prefix) {
    var url = "/Amazon/Home/InsuredCount";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function Amazon_Home_CasePrefixList() {
    var url = "/Amazon/Home/CasePrefixList";

    return url;
}

export function Flex_Home_CaseList(insurer,
    insured,
    wkwReference,
    insurerReference,
    group,
    prefix,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/Flex/Home/CaseList";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function Standard_CustomReport_FlexStandardReport() {
    return "/Standard/CustomReport/FlexStandardReport";
}   

export function Standard_CustomReport_StorageClaimReport() {
    var url = "/Standard/CustomReport/StorageClaimReport";

    return url;
}

export function Standard_CustomReport_FlexCustomReport(insuredId) {
    var url = "/Standard/CustomReport/FlexCustomReport";

    url = url + "?insured=" + encodeURIComponent(insuredId);

    return url;
}

export function Standard_CustomReport_FlexInsuredList() {
    var url = "/Standard/CustomReport/FlexInsuredList";

    return url;
}

export function Standard_CustomReport_FMGlobalGeneralReport() {
    var url = "/Standard/CustomReport/FMGlobalGeneralReport";

    return url;
}

export function Standard_CustomReport_FMGlobalStandardReport() {
    var url = "/Standard/CustomReport/FMGlobalStandardReport";

    return url;
}

/*
 * Generic URLS
 */
export function Generic_NewClaim_RegisterClaim(setPassword, email) {
    var url = "/Generic/NewClaim/RegisterClaim";
    url = url + "?setPassword=" + setPassword;
    url = url + "&email=" + email;

    return url;
}

export function Generic_Case_GetCase(id) {
    var url = "/Generic/Case/GetCase";

    url = url + "?id=" + id;

    return url;
}

export function Generic_Home_InsuredList() {
    var url = "/Generic/Home/InsuredList";

    return url;
}

export function Generic_Home_InsurerList() {
    var url = "/Generic/Home/InsurerList";

    return url;
}

export function Generic_Home_WkwReferenceList(match) {
    var url = "/Generic/Home/WkwReferenceList";
    url = url + "?match=" + match;

    return url;
}

export function Generic_Home_ClaimSubmitterNameList(match) {
    var url = "/Generic/Home/ClaimSubmitterNameList";
    url = url + "?match=" + match;

    return url;
}

export function Generic_Home_ClientReferenceList(match) {
    var url = "/Generic/Home/ClientReferenceList";
    url = url + "?match=" + match;

    return url;
}

export function Generic_Home_CaseList(insurer,
    insured,
    wkwReference,
    claimSubmitterName,
    insurerReference,
    group,
    prefix,
    fileStatus,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/Generic/Home/CaseList";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&claimSubmitterName=" + encodeURIComponent(claimSubmitterName);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&fileStatus=" + encodeURIComponent(fileStatus);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function Generic_Home_DownloadCaseReport(insurer,
    insured,
    wkwReference,
    claimSubmitterName,
    insurerReference,
    group,
    prefix) {
    var url = "/Generic/Home/DownloadCaseReport";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&claimSubmitterName=" + encodeURIComponent(claimSubmitterName);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);

    return url;
}

function GenericDashboard(url, insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    //url = url + "?insured=" + insured;
    //url = url + "&insurer=" + insurer;
    //url = url + "&claimDateFrom=" + claimDateFrom;
    //url = url + "&claimDateTo=" + claimDateTo;
    //url = url + "&shipDateFrom=" + shipDateFrom;
    //url = url + "&shipDateTo=" + shipDateTo;
    //url = url + "&closedDateFrom=" + closedDateFrom;
    //url = url + "&closedDateTo=" + closedDateTo;
    //url = url + "&policyNumber=" + policyNumber;
    //url = url + "&status=" + status;

    return url;
}


export function Dashboards_Generic_OpenVsClosed(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/OpenVsClosed",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Generic_PaidAndOutstanding(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/PaidAndOutstanding",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_CauseOfLoss(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/CauseOfLoss",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_ClaimsByMonth(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/ClaimsByMonth",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_ClaimValues(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/ClaimValues",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_DaysFromAdviceToSettlement(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/DaysFromAdviceToSettlement",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_BiggestClaims(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/BiggestClaims",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_RecoveriesByYear(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status, successfulOnly) {

    var url = GenericDashboard("/Dashboards/Generic/RecoveriesByYear",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    //url = url + "&successfulOnly=" + successfulOnly;
    url = url + "?successfulOnly=" + successfulOnly;

    return url;
}

export function Dashboards_Generic_ClaimsSummary(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/ClaimsSummary",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}


export function Dashboards_Generic_ReasonsForNoRecovery(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/ReasonsForNoRecovery",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_ClaimValueAmounts(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/ClaimValueAmounts",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Dashboards_Generic_ClaimsByOpponent(insured,
    insurer,
    claimDateFrom,
    claimDateTo,
    shipDateFrom,
    shipDateTo,
    closedDateFrom,
    closedDateTo,
    policyNumber,
    status) {

    var url = GenericDashboard("/Dashboards/Generic/ClaimsByOpponent",
        insured,
        insurer,
        claimDateFrom,
        claimDateTo,
        shipDateFrom,
        shipDateTo,
        closedDateFrom,
        closedDateTo,
        policyNumber,
        status);

    return url;
}

export function Standard_CustomReport_GenericReport() {
    var url = "/Generic/CustomReport/GenericReport";

    return url;
}

export function Standard_Generic_Email(caseid, text) {
    var url = "/Generic/Case/SendEmail";
    url = url + "?wkwreference=" + encodeURIComponent(caseid);
    url = url + "&text=" + encodeURIComponent(text);

    return url;
}

// Generic report

export function Generic_Report_AllCasesReport() {
    var url = "/Generic/Report/AllCasesReport";

    return url;
}

export function Generic_Report_AllOpenCasesReport() {
    var url = "/Generic/Report/AllOpenCasesReport";

    return url;
}

export function Generic_Report_OpenCargoReport() {
    var url = "/Generic/Report/OpenCargoReport";

    return url;
}

export function Generic_Report_OpenRecoveriesReport() {
    var url = "/Generic/Report/OpenRecoveriesReport";

    return url;
}

export function Generic_Report_ConcludedRecoveriesReport() {
    var url = "/Generic/Report/ConcludedRecoveriesReport";

    return url;
}

export function GenericGeneralReport(url, group, prefix, insurer, insured, dateFrom, dateTo) {
    url = url + "?group=" + encodeURIComponent(group);
    url = url + "&prefix=" + encodeURIComponent(prefix);
    url = url + "&insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);

    return url;
}

export function Generic_Report_GetUserAccess() {
    var url = "/Generic/Report/GetUserAccess";

    return url;
}

export function Generic_Report_GetGroupList() {
    var url = "/Generic/Report/GetGroupList";

    return url;
}

export function Generic_Home_InsuredCount(prefix) {
    var url = "/Generic/Home/InsuredCount";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function Generic_Home_CasePrefixList() {
    var url = "/Generic/Home/CasePrefixList";

    return url;
}

export function Generic_Case_GetGenericStatus(caseId) {
    return "/Generic/Case/GetGenericStatus?id=" + encodeURIComponent(caseId);
}

export function Generic_Case_SetFinalisedStatus() {
    return "/Generic/Case/SetFinalisedStatus";

}
export function Standard_CustomReport_GenericWeeklyReport() {
    var url = "/Standard/CustomReport/GenericWeeklyReport";

    return url;
}

export function Standard_CustomReport_GenericFreightNorthAmerica() {
    var url = "/Standard/CustomReport/GenericFreightNorthAmericaReport";

    return url;
}

export function Standard_CustomReport_GenericPendingCargoClaims(dateOfLossFrom, dateOfLossTo, dateClaimReportedFrom, dateClaimReportedTo, causeOfLoss) {
    var url = "/Standard/CustomReport/GenericPendingCargoClaims";
    url = url + "?dateOfLossFrom=" + encodeURIComponent(dateOfLossFrom);
    url = url + "&dateOfLossTo=" + encodeURIComponent(dateOfLossTo);
    url = url + "&dateClaimReportedFrom=" + encodeURIComponent(dateClaimReportedFrom);
    url = url + "&dateClaimReportedTo=" + encodeURIComponent(dateClaimReportedTo);
    url = url + "&causeOfLoss=" + encodeURIComponent(causeOfLoss);

    return url;
}

export function Standard_CustomReport_GenericCauseOfLossList() {
    var url = "/Standard/CustomReport/GenericCauseOfLossList";

    return url;
}

export function SantaFe_Home_InsurerList() {
    return "/santafe/Home/InsurerList";
}

export function SantaFe_Home_InsuredList(prefix, search) {
    var url = "/santafe/Home/InsuredList";
    url = url + "?prefix=" + encodeURIComponent(prefix);
    url = url + "&search=" + encodeURIComponent(search);

    return url;
}

export function SantaFe_Home_InsuredCount(prefix) {
    var url = "/santafe/Home/InsuredCount";
    url = url + "?prefix=" + encodeURIComponent(prefix);

    return url;
}

export function SantaFe_Home_WkwReferenceList(match) {
    var url = "/santafe/Home/WkwReferenceList";
    url = url + "?match=" + encodeURIComponent(match);

    return url;
}

export function SantaFe_Home_CasePrefixList() {
    var url = "/santafe/Home/CasePrefixList";

    return url;
}

export function SantaFe_Home_CaseList(
    insurer,
    insured,
    wkwReference,
    insurerReference,
    pageNumber,
    pageSize,
    orderBy,
    orderAsc) {

    var url = "/santafe/home/summary";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);
    url = url + "&pageNumber=" + encodeURIComponent(pageNumber);
    url = url + "&pageSize=" + encodeURIComponent(pageSize);
    url = url + "&orderBy=" + encodeURIComponent(orderBy);
    url = url + "&orderAsc=" + encodeURIComponent(orderAsc);

    return url;
}

export function SantaFe_Report_DownloadCaseReport(insurer,
    insured,
    wkwReference,
    insurerReference) {
    var url = "/santafe/report/standarddownload";
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&wkwReference=" + encodeURIComponent(wkwReference);
    url = url + "&insurerReference=" + encodeURIComponent(insurerReference);

    return url;
}

export function SantaFe_Case_GetCase(id) {
    var url = "/santafe/case/getcase";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function SantaFe_Case_CaseClosed(id) {
    var url = "/santafe/Case/CaseClosed";
    url = url + "?id=" + encodeURIComponent(id);

    return url;
}

export function SantaFe_Report_GetGroupList() {
    var url = "/santafe/Report/GetGroupList";

    return url;
}

export function SantaFe_Lookups_GetOfficeList() {
    return "/santafe/lookups/santafeofficedropdown";
}

export function SantaFe_Lookups_GetRegionList() {
    return "/santafe/lookups/santaferegiondropdown";
}

export function SantaFe_Lookups_GetCorporateAccountList() {
    return "/santafe/lookups/santafecorporateaccountdropdown";
}

export function SantaFe_Lookups_GetPolicyPeriodList() {
    return "/santafe/lookups/santafepolicyperiodsdropdown";
}

export function SantaFe_Lookups_LossTypes() {
    return "/santafe/lookups/santafelosstypesdropdown";
}

export function SantaFe_Lookups_ClaimHandlers() {
    return "/santafe/lookups/santafeclaimhandlers";
}

export function SantaFe_Lookups_ClaimStatus() {
    return "/santafe/lookups/santafeclaimstatuslist";
}

export function SantaFe_Lookups_VoyageTypes() {
    return "/santafe/lookups/santafevoyagetypes";
}

export function SantaFe_Lookups_CommonCurrencies() {
    return "/santafe/lookups/santafecurrencies?commonOnly=true";
}

export function SantaFeGeneralReport(url, insurer, insured, dateFrom, dateTo) {
    url = url + "?insurer=" + encodeURIComponent(insurer);
    url = url + "&insured=" + encodeURIComponent(insured);
    url = url + "&dateFrom=" + encodeURIComponent(dateFrom);
    url = url + "&dateTo=" + encodeURIComponent(dateTo);

    return url;
}

export function SantaFe_Report_AllCasesReport() {
    return "/santafe/report/allcases";
}

export function SantaFe_Report_AllOpenCasesReport() {
    return "/santafe/report/allopencases";
}

export function SantaFe_Report_OpenCargoReport() {
    return "/santafe/report/opencargo";
}

export function SantaFe_Report_OpenRecoveriesReport() {
    return "/santafe/report/openrecoveries";
}

export function SantaFe_Report_ConcludedRecoveriesReport() {
    return "/santafe/report/concludedrecoveries";
}

export function SantaFe_Transfer_Claim() {
    return "/santafe/manage/transferclaim";
}

export function SantaFe_Transfer_WKW_Claim() {
    return "/santafe/manage/wkwtransferclaim";
}

export function SantaFe_Payment_Request() {
    return "/santafe/manage/paymentrequest";
}

export function SantaFe_Update_Case() {
    return "/santafe/manage/update";
}

export function SantaFe_Custom_GeneralReport(
    officeId,
    region,
    accountId,
    handlerId,
    claimStatusId,
    openedFrom,
    openedTo,
    closedFrom,
    closedTo,
    amountFrom,
    amountTo,
    policyPeriodId) {

    var url = "/santafe/clientreport/generalreport";
    url = url + "?officeId=" + encodeURIComponent(officeId);
    url = url + "&region=" + encodeURIComponent(region);
    url = url + "&accountId=" + encodeURIComponent(accountId);
    url = url + "&handlerId=" + encodeURIComponent(handlerId);
    url = url + "&claimStatusId=" + encodeURIComponent(claimStatusId);
    url = url + "&openedFrom=" + encodeURIComponent(openedFrom);
    url = url + "&openedTo=" + encodeURIComponent(openedTo);
    url = url + "&closedFrom=" + encodeURIComponent(closedFrom);
    url = url + "&closedTo=" + encodeURIComponent(closedTo);
    url = url + "&amountFrom=" + encodeURIComponent(amountFrom);
    url = url + "&amountTo=" + encodeURIComponent(amountTo);
    url = url + "&policyPeriodId=" + encodeURIComponent(policyPeriodId);

    return url;
}


// WEBPACK FOOTER //
// ./wwwroot/js/dataUrls.js